import React, { useState, useRef, useEffect, useCallback } from 'react';
import moment from "moment-timezone";
import { useTranslation } from 'react-i18next';

import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

import DatePicker from "react-datepicker";

import 'react-datepicker/dist/react-datepicker.css';

import * as XLSX from 'xlsx';

import { useNavigate, useLocation } from "react-router-dom";

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { user } from '../common/user'; // Import the user object
import { useAuth } from '../../contexts/AuthContext.js'; // Import useAuth to access caraUser
import { industryPreFillMapNist } from '../ComplianceOperations/AllFrameworksData';
import { handleControlsPdfDownload } from "./SmartMapControlsPdfExport";
import { handleEvidencePdfDownload } from "./SmartMapEvidencePdfExport";
const { getMyUsers } = user;
const API_URL = process.env.REACT_APP_API_URL;
console.log("API_URL =>", API_URL); // <-- Add this for debugging

// Helper function to transform Smart Map controls data to UI structure
const transformControlsToFramework = (controls) => {
  // Put all controls in a single "ALL" category
  const allItems = [];
  const contentMapData = {
    ALL: { description: "Smart Map - Cross-Framework Control Mappings" }
  };

  // Create individual items for each control
  controls.forEach(control => {
    const nistId = control["NIST Subcategory ID"];
    if (!nistId) return;
    // Create individual item for each control
    const item = {
      functionName: "ALL",
      categoryCode: nistId,
      subcategory: control["NIST Subcategory (short)"],
      heading: "",
      questions: [{
        categoryid: nistId,
        question: control["NIST Subcategory (short)"],
        task: control["NIST Subcategory (short)"],
        subcategory: control["NIST Subcategory (short)"],
        examples: [],
        commonControlId: control["Common Control ID"],
        isoControls: control["ISO/IEC 27001:2022 Annex A Clauses (IDs)"],
        cisControls: control["CIS Controls v8 (IDs)"],
        mappingStrength: control["Mapping Strength"],
        evidenceType: control["Evidence Type"],
        autoUpdate: control["Auto-Update Feasibility"]
      }]
    };

    allItems.push(item);
  });

  return {
    dataMap: { ALL: { category: "Smart Map Controls", items: allItems } },
    contentMap: contentMapData,
    dataMapData: controls
  };
};

const ViewSmartMap = () => {
  const { t } = useTranslation(['smart_map', 'framework_common', 'common']);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cid = queryParams.get('cid');

  // Load Smart Map control data from API
  const [dataMap, setDataMap] = useState(null);
  const [contentMap, setContentMap] = useState(null);
  const [dataMapData, setDataMapData] = useState(null);
  const [frameworkLoading, setFrameworkLoading] = useState(true);
  const [frameworkError, setFrameworkError] = useState(null);
  const [, setControlsData] = useState([]);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetchFramework = () => {
    setRefetchTrigger(prev => prev + 1);
  };

  // Fetch Smart Map Framework Data
  useEffect(() => {
    const fetchSmartMapData = async () => {
      try {
        setFrameworkLoading(true);
        const response = await axios.get(`${API_URL}api/get_smartmap_framework_data/`, {
          withCredentials: true,
        });

        if (response.data.status === "SUCCESS") {
          const controls = response.data.controls || [];
          setControlsData(controls);

          // Transform controls data to match NIST CSF 2.0 structure
          const transformedData = transformControlsToFramework(controls);
          setDataMap(transformedData.dataMap);
          setContentMap(transformedData.contentMap);
          setDataMapData(transformedData.dataMapData);

          console.log('Smart Map data loaded:', controls.length, 'controls');
        } else {
          setFrameworkError(t('msg.failedToLoadSmartMapFrameworkData', { ns: 'smart_map', defaultValue: 'Failed to load Smart Map framework data' }));
        }
      } catch (error) {
        console.error("Error fetching Smart Map framework data:", error);
        setFrameworkError(t('msg.errorLoadingSmartMapFrameworkWithError', { ns: 'smart_map', defaultValue: 'Error loading Smart Map framework: {{errorMessage}}', errorMessage: error.message }));
      } finally {
        setFrameworkLoading(false);
      }
    };

    fetchSmartMapData();
  }, [refetchTrigger]);



  // Debug: Log dataMap when it changes

  useEffect(() => {

    if (dataMap) {

      console.log(' ViewSmartMap - dataMap loaded:', Object.keys(dataMap));

      console.log(' ViewSmartMap - GOVERN data:', dataMap?.GOVERN);

    }

  }, [dataMap]);



  const { caraUser } = useAuth(); // Access caraUser to get industry type



  // ======================= Excel sheet coverpage logic ======================= // 

  // State: User Profile Data (fetched from API like Profile.js)

  const [profileData, setProfileData] = useState({

    first_name: '',

    last_name: '',

    email: '',

    username: '',

  });



  // State: NIST Framework Data (fetched from API for security)

  const [, setNistFrameworkData] = useState([]);

  // =====================================================================//

  // State: Category and UI Controls

  const [activeButton, setActiveButton] = useState("ALL");

  const [openCardIndex, setOpenCardIndex] = useState(null);

  const [, setSelectedItem] = useState(null);

  const [, setNistData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [, setError] = useState("");

  const [evidenceTableData, setEvidenceTableData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = 5;



  const [showControlsDropdown, setShowControlsDropdown] = useState(false);

  const [showEvidenceDropdown, setShowEvidenceDropdown] = useState(false);


  const today = moment().format('YYYY-MM-DD');

  // Which category_ids have at least one evidence

  const [evidenceIdsSet, setEvidenceIdsSet] = useState(new Set());



  // Task counts per category_id (e.g., {"GV.SC-01": 2})

  const [taskCountByCategory, setTaskCountByCategory] = useState({});
  const [isEvidenceSaving, setIsEvidenceSaving] = useState(false);
  const [evidenceFiles, setEvidenceFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({ percentage: 0, show: false });

  // File Validation Constants
  const MAX_FILES_PER_UPLOAD = 5;
  const MAX_FILE_SIZE_MB = 2;
  const MAX_TOTAL_SIZE_MB = 10;



  // Controls   

  const dropdownRef = useRef(null);



  // Close dropdown when clicked outside

  useEffect(() => {

    const handleClickOutside = (event) => {

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {

        setShowControlsDropdown(false);

      }

    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {

      document.removeEventListener('mousedown', handleClickOutside);

    };

  }, []);



  // End



  // Verified Evidence  

  const evidenceRef = useRef(null);



  // Questions Container Ref - to scroll to first question when switching subcategories

  const questionsContainerRef = useRef(null);



  useEffect(() => {

    const handleClickOutside = (event) => {

      if (evidenceRef.current && !evidenceRef.current.contains(event.target)) {

        setShowEvidenceDropdown(false);

      }

    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {

      document.removeEventListener('mousedown', handleClickOutside);

    };

  }, []);

  // End







  // State: Evidence & File Uploads



  const [evidenceDate, setEvidenceDate] = useState("");
  const [gatheringMethod, setGatheringMethod] = useState("");

  const [verified, setVerified] = useState(false);

  const [ownerEmail, setOwnerEmail] = useState("");

  const fileInputRef = useRef();

  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const resetEvidenceModal = () => {
    setEvidenceDate("");
    setEvidenceFiles([]);
    setGatheringMethod("");
    setVerified(false);
    setOwnerEmail(caraUser?.email || "");
  };

  // State: Calendar




  // State: Dropdowns and Selections



  const [activePriority, setActivePriority] = useState({});

  const [activeStatus, setActiveStatus] = useState({});

  const [isResetEnabled, setIsResetEnabled] = useState(false);

  const [isCheckingData, setIsCheckingData] = useState(false);



  // Check if any priority or status has been clicked

  const checkIfAnyDataFilled = useCallback(() => {

    if (isCheckingData) {

      console.log(' Already checking data, skipping...');

      return;

    }



    setIsCheckingData(true);

    console.log(' Checking data:', { activePriority, activeStatus });



    // Check activePriority

    const hasPriority = Object.values(activePriority).some(categoryData =>

      Object.values(categoryData).some(value => value && value !== "N/A")

    );



    // Check activeStatus

    const hasStatus = Object.values(activeStatus).some(categoryData =>

      Object.values(categoryData).some(value => value && value !== "N/A")

    );



    // Enable Reset if both priority AND status have been clicked

    const shouldEnable = hasPriority && hasStatus;



    console.log(' Reset Button check:', {

      hasPriority,

      hasStatus,

      shouldEnable,

      priorityKeys: Object.keys(activePriority),

      statusKeys: Object.keys(activeStatus),

      currentState: isResetEnabled

    });



    // Only update if state actually changed

    if (isResetEnabled !== shouldEnable) {

      console.log(' State change needed:', { from: isResetEnabled, to: shouldEnable });

      setIsResetEnabled(shouldEnable);

    } else {

      console.log(' No state change needed');

    }



    // Reset checking flag after a short delay

    setTimeout(() => {

      setIsCheckingData(false);

    }, 100);

  }, [activePriority, activeStatus, isResetEnabled, isCheckingData]);



  // Check existing data when activePriority or activeStatus changes

  useEffect(() => {

    console.log(' activePriority or activeStatus changed:', { activePriority, activeStatus });



    // Only check if we have actual data (not empty objects)

    if (Object.keys(activePriority).length > 0 || Object.keys(activeStatus).length > 0) {

      console.log(' Data detected, checking...');

      checkIfAnyDataFilled();

    } else {

      console.log(' No data yet, skipping check');

    }

  }, [activePriority, activeStatus, checkIfAnyDataFilled]);



  // Initial check after data loads (only once)

  useEffect(() => {

    const timer = setTimeout(() => {

      console.log(' Final data check after 4 seconds');

      checkIfAnyDataFilled();

    }, 4000); // Wait 4 seconds for all data to load



    return () => clearTimeout(timer);

  }, [checkIfAnyDataFilled]); // Run only once on mount



  // State: Users & Owners




  // State: Input




  // State: Assessment

  const [assessment, setAssessment] = useState(null);



  // State: Examples




  // Refs

  const resetProfileRef = useRef(null);// Reset Button



  // Navigation

  const navigate = useNavigate();







  // Examples

  const [selectedExampleId] = useState('');





  const getExamplesForId = (exampleId) => {

    for (const categoryKey in dataMap) {

      const items = dataMap[categoryKey]?.items || [];



      for (const item of items) {

        const matchedQuestion = item.questions?.find(

          (q) => q.categoryid.replace(':', '') === exampleId.replace(':', '')

        );

        if (matchedQuestion) {

          return matchedQuestion.examples || [];

        }

      }

    }



    return [];

  };







  // Excel Sheet...................


  const [fetchData, setFetchData] = useState(null);




  const handleControlsPdfDownloadClick = () => {
    if (!contentMap || !fetchData) {
      alert(t('msg.requiredDataNotLoadedRetry', { ns: 'framework_common', defaultValue: ' Required data is not loaded yet. Please try again.' }));
      return;
    }

    const userData = {
      first_name: caraUser?.first_name || profileData?.first_name || "",
      last_name: caraUser?.last_name || profileData?.last_name || "",
      username: caraUser?.username || profileData?.username || "User",
      email: caraUser?.email || profileData?.email || ownerEmail || ""
    };

    handleControlsPdfDownload(
      fetchData,
      setShowControlsDropdown,
      contentMap,
      dataMap,
      profileData?.email || caraUser?.email || ownerEmail || "",
      undefined,
      assessment?.scope || "",
      userData
    );
  };

  const handleControlsExcelDownload = () => {

    const controlData = [];



    Object.entries(fetchData?.categories || {}).forEach(([_, categoryObj]) => {

      categoryObj.subcategories?.forEach((subcat) => {

        subcat.questions?.forEach((q) => {

          controlData.push({

            "Category ID": q.category_id,

            "Category": q.task,

            "Sub Category": q.question,

            "Priority": q.priority,

            "Result": q.status,

            "Remark": q.notes || "",

          });

        });

      });

    });



    if (controlData.length > 0) {

      const worksheet = XLSX.utils.json_to_sheet(controlData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Controls");



      XLSX.writeFile(workbook, "Controls_List.xlsx");



      alert(t('msg.controlsExcelDownloadedSuccess', { ns: 'framework_common', defaultValue: 'Controls Excel file downloaded successfully!' }));



      // Dropdown Close

      setShowControlsDropdown(false);

    } else {

      alert(t('msg.noControlDataAvailableForExport', { ns: 'framework_common', defaultValue: ' No control data available for export.' }));

      setShowControlsDropdown(false);

    }

  };



  useEffect(() => {

    if (cid) {

      axios

        .get(`${API_URL}api/get_smartmap_data/?cid=${cid}`, { withCredentials: true })

        .then((response) => {

          setFetchData(response.data);

        })

        .catch((error) => {

          console.error("Error fetching Smart Map data:", error);

          setFetchData(null);

        });

    }

  }, [cid]);

  // End

  // Second Excel

  const handleEvidencePdfDownloadClick = () => {
    if (!contentMap || !fetchData) {
      alert(t('msg.requiredDataNotLoadedRetry', { ns: 'framework_common', defaultValue: ' Required data is not loaded yet. Please try again.' }));
      return;
    }

    const userData = {
      first_name: caraUser?.first_name || profileData?.first_name || "",
      last_name: caraUser?.last_name || profileData?.last_name || "",
      username: caraUser?.username || profileData?.username || "User",
      email: caraUser?.email || profileData?.email || ownerEmail || ""
    };

    handleEvidencePdfDownload(
      fetchData,
      setShowEvidenceDropdown,
      contentMap,
      dataMap,
      profileData?.email || caraUser?.email || ownerEmail || "",
      "Evidence Audit Report",
      assessment?.scope || "",
      userData
    );
  };

  const handleEvidenceExcelDownload = () => {

    const controlData = [];



    Object.entries(fetchData?.categories || {}).forEach(([_, categoryObj]) => {

      categoryObj.subcategories?.forEach((subcat) => {

        subcat.questions?.forEach((q) => {

          const baseRow = {

            "Category ID": q.category_id,

            "Category": q.task,

            "Sub Category": q.question,

            "Priority": q.priority,

            "Result": q.status,

            "Remark": q.notes || "",

          };



          if (Array.isArray(q.evidence) && q.evidence.length > 0) {

            const filenames = [];

            const verifiedValues = [];



            q.evidence.forEach((ev) => {

              // Filename logic

              let fileName = "Not Uploaded";

              if (ev.s3_path) {

                fileName = ev.file_name?.trim() !== "" ? ev.file_name : "Unnamed File";

              }

              filenames.push(fileName);



              // Verified logic

              const val = ev.verified_evidence;

              if (val === true || val === "true") verifiedValues.push("Yes");

              else if (val === false || val === "false") verifiedValues.push("No");

              else if (val?.trim?.() !== "") verifiedValues.push(val);

              else verifiedValues.push("Not Available");

            });



            controlData.push({

              ...baseRow,

              "Filename": filenames.join(", "),

              "Verified Evidence": verifiedValues.join(", "),

            });



          } else {

            // No evidence at all

            controlData.push({

              ...baseRow,

              "Filename": "Not Uploaded",

              "Verified Evidence": "Not Available",

            });

          }

        });

      });

    });



    if (controlData.length > 0) {

      const worksheet = XLSX.utils.json_to_sheet(controlData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Verified Evidence");



      XLSX.writeFile(workbook, "Verified_Evidence.xlsx");



      alert(t('msg.verifiedEvidenceExcelDownloadedSuccess', { ns: 'framework_common', defaultValue: 'Verified Evidence Excel file downloaded successfully!' }));

      setShowEvidenceDropdown(false);

    } else {

      alert(t('msg.noControlDataAvailableForExport', { ns: 'framework_common', defaultValue: ' No control data available for export.' }));

      setShowEvidenceDropdown(false);

    }

  };

  // End

  // Static Data - removed top navigation buttons



  // Filters All select     

  const clearFiltersfilter = () => {

    setPriorityFilter('All');

    setPostureFilter('All');

    setComboPriorityFilter('');

    setComboPostureFilter('');

  };

  const [users, setUsers] = useState([]);



  // Fetch users on component mount

  useEffect(() => {

    const fetchUsers = async (caraUser) => {

      try {

        const fetchedUsers = await getMyUsers(caraUser);

        console.log('Fetched users:', fetchedUsers);



        const allUsers = fetchedUsers.filter(u => u.first_name || u.last_name);

        // Remove duplicates by name to prevent multiple selections of the same name
        const uniqueUsers = Array.from(
          new Map(
            allUsers.map((u) => {
              const fullName = `${u.first_name || ""} ${u.last_name || ""}`.trim();
              return [fullName, u];
            })
          ).values()
        );

        console.log('Unique Users:', uniqueUsers);

        setUsers(uniqueUsers); // Store unique users in state

      } catch (error) {

        console.error('Error fetching users:', error);

        setUsers([]); // Set empty array on error

      }

    };



    fetchUsers(caraUser);

  }, [caraUser]);



  const [priorityFilter, setPriorityFilter] = useState('All');

  const [postureFilter, setPostureFilter] = useState('All');

  const [comboPriorityFilter, setComboPriorityFilter] = useState('');

  const [comboPostureFilter, setComboPostureFilter] = useState('');



  const dropdownStyle = {

    height: '35px',

    padding: '0.4rem 0.75rem',

    fontSize: '0.875rem',

    appearance: 'none',

    backgroundColor: '#f8f9fa',

  };



  const chevronStyle = {

    right: "10px",

    top: "50%",

    transform: "translateY(-50%)",

    pointerEvents: "none",

    color: "#6c757d",

  };



  const priority = ["High", "Medium", "Low"];

  const priorityLabelKeys = {
    "High": "priority.high",
    "Medium": "priority.medium",
    "Low": "priority.low",
  };

  const status = [

    "In Practice",

    "Fully Implemented",

    "Largely Implemented",

    "Partially Implemented",

    "Not Implemented",

    "Not Applicable"

  ];

  const statusLabelKeys = {
    "In Practice": "status.inPractice",
    "Fully Implemented": "status.fullyImplemented",
    "Largely Implemented": "status.largelyImplemented",
    "Partially Implemented": "status.partiallyImplemented",
    "Not Implemented": "status.notImplemented",
    "Not Applicable": "status.notApplicable",
  };





  // Fetch User Profile Data from API (like Profile.js)

  useEffect(() => {

    const fetchProfileData = async () => {

      try {

        console.log(" Fetching profile data from API...");

        const response = await axios.get(`${API_URL}api/profile_update/`, {

          withCredentials: true,

        });



        console.log("📡 Profile API Response:", response.data);



        if (response.data.status === "SUCCESS") {

          const user = response.data.user;

          if (user) {

            setProfileData({

              first_name: user.first_name || '',

              last_name: user.last_name || '',

              email: user.email || '',

              username: user.username || '',

            });

            console.log("Profile data loaded successfully:", {

              first_name: user.first_name,

              last_name: user.last_name,

              has_email: !!user.email,

              has_username: !!user.username

            });

          }

        } else {

          console.warn(" Failed to fetch profile:", response.data.message);

        }

      } catch (error) {

        console.error("Error fetching profile data:", error);

        console.error("Error details:", error.response?.data);

      }

    };



    fetchProfileData();

  }, []);



  // Fetch Smart Map Framework Data from API (for Excel export)

  useEffect(() => {

    const fetchSmartMapFrameworkForExport = async () => {

      try {

        const response = await axios.get(`${API_URL}api/get_smartmap_framework_data/`, {

          withCredentials: true,

        });



        if (response.data.status === "SUCCESS") {

          // Transform controls data for Excel export format

          const exportData = (response.data.controls || []).map(control => [

            control["Common Control ID"],

            control["NIST Subcategory ID"],

            control["NIST Subcategory (short)"],

            control["ISO/IEC 27001:2022 Annex A Clauses (IDs)"].join(", "),

            control["CIS Controls v8 (IDs)"].join(", "),

            control["Mapping Strength"],

            control["Evidence Type"],

            control["Auto-Update Feasibility"],

            "", // Priority placeholder

            "", // Status placeholder

            ""  // Notes placeholder

          ]);

          setNistFrameworkData(exportData);

        } else {

          console.warn("Failed to fetch Smart Map framework data:", response.data.message);

        }

      } catch (error) {

        console.error("Error fetching Smart Map framework data:", error);

        // Fallback to empty array if API fails

        setNistFrameworkData([]);

      }

    };



    fetchSmartMapFrameworkForExport();

  }, []);



  // Effects

  useEffect(() => {

    const backdrop = document.querySelector(".modal-backdrop");

    if (backdrop) {

      backdrop.remove();

      document.body.classList.remove("modal-open");

      document.body.style = "";

    }

  }, []);



  useEffect(() => {

    const fetchAssessment = async () => {

      try {

        const res = await axios.get(`${API_URL}api/get_smartmap_card_assessments/?cid=${cid}`);

        if (res.data.status === 'SUCCESS') {

          setAssessment(res.data.assessments[0]);

        }

      } catch (err) {

        console.error('Error fetching Smart Map assessment:', err);

      }

    };

    if (cid) {
      fetchAssessment();
      fetchEvidenceTableData(); // Fetch evidence on mount to show blue ticks
    }

  }, [cid]);



  useEffect(() => {

    setOpenCardIndex(0);

  }, [activeButton]);




















  // =======================

  // 🛠 Task Creation Section

  // =======================



  // Task Modal State

  const [showCreateModal, setShowCreateModal] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const [selectedCategoryId, setSelectedCategoryId] = useState('');

  const [currentStatus, setCurrentStatus] = useState('');

  const [currentPriority, setCurrentPriority] = useState('');



  const [currentModalCategoryId, setCurrentModalCategoryId] = useState("");



  // Task Form Fields
  const getDefaultDueDate = () => {
    const d = new Date();
    d.setMonth(d.getMonth() + 1);
    return d.toISOString().split("T")[0];
  };

  const [dueDate, setDueDate] = useState(getDefaultDueDate());

  const [taskTitle, setTaskTitle] = useState("");

  const [taskOwner, setTaskOwner] = useState("");

  const [taskDescription, setTaskDescription] = useState("");



  // Task Dropdowns

  const [showOwnerDropdown, setShowOwnerDropdown] = useState(false);




  // Task Data

  const [tasks, setTasks] = useState([]);





  // When switching to a new category, reset to first subcategory

  const handleCategoryChange = useCallback((categoryKey) => {

    setActiveButton(categoryKey);

    setOpenCardIndex(0);



    // Reset selectedItem with first item of the new category

    const firstItem = dataMap[categoryKey]?.items?.[0];

    if (firstItem) {

      setSelectedItem(

        {

          categoryCode: firstItem.categoryCode,

          subcategory: firstItem.subcategory,

          heading: firstItem.heading,

        }

      );

    } else {

      setSelectedItem(null);

    }



    // Reset scroll position to show first question (category ID -01) when switching main categories

    setTimeout(() => {

      if (questionsContainerRef.current) {

        questionsContainerRef.current.scrollTop = 0;

      }

    }, 100);

  }, [dataMap]);



  useEffect(() => {

    if (dataMap) {

      handleCategoryChange("ALL");  // Automatically select ALL category to show all controls

    }

  }, [dataMap, handleCategoryChange]); // Re-run when dataMap loads



  const fetchTasks = useCallback(async (categoryId) => {

    const cleanId = categoryId?.trim().replace(/:$/, ""); // always clean id

    try {

      const response = await axios.get(`${API_URL}api/smartmap_task_management/`, {

        params: { category_id: cleanId, cid, control: "Smart Map" },

        withCredentials: true,

      });



      if (response.status === 200 && Array.isArray(response.data.records)) {

        // Filter tasks by control field to show only Smart Map tasks

        const filteredTasks = response.data.records.filter(task => task.control === "Smart Map");

        setTasks(filteredTasks);

        setTaskCountByCategory(prev => ({

          ...prev,

          [cleanId]: filteredTasks.length

        }));

      } else {

        setTasks([]);

        setTaskCountByCategory(prev => ({ ...prev, [cleanId]: 0 }));

      }

    } catch (error) {

      console.error("Failed to fetch tasks:", error);

      setTasks([]);

      setTaskCountByCategory(prev => ({ ...prev, [cleanId]: 0 }));

    }

  }, [cid]);

  // Fetch tasks when modal category changes

  useEffect(() => {

    if (currentModalCategoryId) {

      fetchTasks(currentModalCategoryId);

    }

  }, [currentModalCategoryId, fetchTasks]);



  useEffect(() => {

    const preloadTaskCounts = async () => {

      const questions =

        dataMap?.[activeButton]?.items?.[openCardIndex]?.questions || [];



      const idsToFetch = questions

        .map(q => q.categoryid?.trim().replace(/:$/, ""))

        .filter(id => id && taskCountByCategory[id] === undefined);



      if (idsToFetch.length === 0) return;



      try {

        const calls = idsToFetch.map(id =>

          axios.get(`${API_URL}api/smartmap_task_management/`, {

            params: { category_id: id, cid, control: "Smart Map" },

            withCredentials: true,

          })

        );



        const results = await Promise.all(calls);

        const updates = {};



        results.forEach((res, i) => {

          const id = idsToFetch[i];

          // Filter by control field to count only Smart Map tasks

          const filteredRecords = Array.isArray(res.data?.records)

            ? res.data.records.filter(task => task.control === "Smart Map")

            : [];

          updates[id] = filteredRecords.length;

        });



        setTaskCountByCategory(prev => ({ ...prev, ...updates }));

      } catch (e) {

        console.error("Preload task counts failed", e);

      }

    };



    if (activeButton && openCardIndex !== null) {

      preloadTaskCounts();

    }

  }, [activeButton, openCardIndex, cid, dataMap, taskCountByCategory]);







  // Save Task Handler

  const handleSave = async () => {

    if (!taskTitle?.trim()) {

      alert(t('msg.taskTitleRequired', { ns: 'framework_common', defaultValue: 'Task title is required' }));

      return false;

    }

    if (!dueDate) {

      alert(t('msg.dueDateRequired', { ns: 'framework_common', defaultValue: 'Due date is required' }));

      return false;

    }

    if (!currentModalCategoryId) {

      alert(t('msg.categoryIdMissingReopenModal', { ns: 'smart_map', defaultValue: 'Category ID is missing. Please open the task modal again.' }));

      return false;

    }

    if (!cid) {

      alert(t('msg.cidMissingRefreshPage', { ns: 'smart_map', defaultValue: 'CID is missing. Please refresh the page.' }));

      return false;

    }



    const firstName = profileData?.first_name || caraUser?.first_name || "";
    const lastName = profileData?.last_name || caraUser?.last_name || "";
    const createdByName = `${firstName} ${lastName}`.trim() || "N/A";

    // Compute IST time (UTC + 5:30)
    const nowUtc = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istNow = new Date(nowUtc.getTime() + istOffset);
    const createdAtNow = istNow.toISOString().replace("T", " ").slice(0, 19);

    const payload = {

      category_id: currentModalCategoryId.trim(),

      cid: cid.trim(),

      framework: assessment?.framework || "",

      taskTitle: taskTitle.trim(),

      taskOwner: taskOwner || "",

      taskDescription: taskDescription?.trim() || "",

      status: currentStatus || "N/A",

      priority: currentPriority || "N/A",

      control: "Smart Map",

      dueDate: dueDate.trim(),

      created_by: createdByName,

      created_at: createdAtNow,

    };


    console.log("Saving task with payload:", payload);

    try {

      const response = await axios.post(`${API_URL}api/smartmap_task_management/`, payload, {

        withCredentials: true,

      });

      if (response.status === 201) {

        toast.success(t('msg.taskSavedSuccess', { ns: 'framework_common', defaultValue: 'Task saved successfully!' }));



        // Reset form

        setDueDate(getDefaultDueDate());

        setTaskTitle("");

        setTaskOwner("");

        setTaskDescription("");

        setShowOwnerDropdown(false);



        // Refresh task list

        fetchTasks(currentModalCategoryId);



        return true;

      }

    } catch (error) {

      console.error("Error saving task:", error);
      console.error("Error response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message;
      alert(t('msg.failedToSaveTaskWithError', { ns: 'smart_map', defaultValue: 'Failed to save task: {{errorMessage}}', errorMessage }));

    }



    return false;

  };







  // ================================

  // 🛠 Upload Evidence Section

  // ================================



  // Upload Evidence category Wise

  // Fetch Evidence Table Data without Duplicates

  const fetchEvidenceTableData = async () => {

    try {

      const queryParams = new URLSearchParams(window.location.search);

      const cid = queryParams.get("cid");

      if (!cid) return;



      const res = await axios.get(`${API_URL}api/get_smartmap_data/?cid=${cid}`, {

        headers: { "Content-Type": "application/json" },

        withCredentials: true,

      });



      const categories = res.data?.categories || {};

      let evidenceRows = [];



      Object.entries(categories).forEach(([catName, catData]) => {

        const functionName = catName.split(" ")[0]; // e.g. "GOVERN"

        catData.subcategories?.forEach((subcat) => {

          subcat.questions?.forEach((q) => {

            if (Array.isArray(q.evidence)) {

              q.evidence.forEach((ev) => {

                evidenceRows.push({

                  uploadedDate: ev.uploaded_date || "",

                  collectionDate: ev.evidence_date || "",

                  function: functionName,

                  subCategory: subcat.subcategory_name || "",

                  categoryId: q.category_id || "",

                  verified: ev.verified_evidence === true || ev.verified_evidence === "true",

                  fileName: ev.file_name,

                  s3Path: ev.s3_path,

                });

              });

            }

          });

        });

      });



      // Always show all evidence (no deduping)

      setEvidenceTableData(evidenceRows);

      // Build a quick lookup set for "has evidence"

      const ids = new Set();

      evidenceRows.forEach((row) => {

        const cleaned = row.categoryId?.replace(/:$/, "");

        if (cleaned) ids.add(cleaned);

      });

      setEvidenceIdsSet(ids);



    } catch (err) {

      console.error("Error fetching evidence data", err);

    }

  };





  useEffect(() => {

    fetchEvidenceTableData();

  }, [cid]);



  // Evidence Upload Handler   

  const [emailError, setEmailError] = useState("");

  const handleEvidenceSubmit = async () => {

    // Email format regex

    const emailRegex = /^\S+@\S+\.\S+$/;



    // Required field check

    if (!evidenceDate || evidenceFiles.length === 0 || !ownerEmail || !gatheringMethod.trim() || !verified) {
      toast.warn(t('msg.fillRequiredFieldsSelectFiles', { ns: 'smart_map', defaultValue: ' Please fill all required fields and select files.' }), { position: "top-right" });
      return;
    }





    // Email format check
    if (!emailRegex.test(ownerEmail.trim())) {
      toast.warn(t('msg.enterValidEmailAddressWarn', { ns: 'smart_map', defaultValue: ' Enter a valid email address.' }), { position: "top-right" });
      return;
    }

    // --- Added Validation for Limits ---
    if (evidenceFiles.length > MAX_FILES_PER_UPLOAD) {
      toast.warning(t('msg.maxFilesAllowedPerUpload', { ns: 'smart_map', defaultValue: 'Maximum {{maxFiles}} files allowed per upload.', maxFiles: MAX_FILES_PER_UPLOAD }), { position: 'top-right', autoClose: 3000 });
      return;
    }

    let totalBytes = 0;
    for (const file of evidenceFiles) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        toast.warning(t('msg.fileExceedsSizeLimitSmartMap', { ns: 'smart_map', defaultValue: 'File "{{fileName}}" exceeds the {{maxSizeMB}}MB limit.', fileName: file.name, maxSizeMB: MAX_FILE_SIZE_MB }), { position: 'top-right', autoClose: 4000 });
        return;
      }
      totalBytes += file.size;
    }

    if (totalBytes > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
      toast.warning(t('msg.totalUploadSizeExceedsLimitSmartMap', { ns: 'smart_map', defaultValue: 'Total upload size exceeds the {{maxTotalMB}}MB limit.', maxTotalMB: MAX_TOTAL_SIZE_MB }), { position: 'top-right', autoClose: 4000 });
      return;
    }
    // -----------------------------------



    const activeItem = dataMap?.[activeButton]?.items?.[openCardIndex];



    const activeCategoryEntry = Object.entries(dataMap).find(

      ([key, value]) =>

        value.items?.some(

          (item) =>

            item.categoryCode === activeItem?.categoryCode &&

            item.subcategory === activeItem?.subcategory

        )

    );



    const fullCategoryName = activeCategoryEntry?.[1]?.category || "";

    const questionText = selectedQuestion?.question || "Unknown";

    const categoryId = selectedQuestion?.categoryid?.replace(/:$/, "") || "";



    setIsEvidenceSaving(true);
    setUploadProgress({ percentage: 0, show: true });

    try {
      const formData = new FormData();
      formData.append("cid", cid);
      formData.append("subcategory_name", activeItem?.subcategory);
      formData.append("question_text", questionText);
      formData.append("category_id", categoryId);
      formData.append("evidence_date", evidenceDate);
      formData.append("gathering_method", gatheringMethod || "");
      formData.append("verified_evidence", verified ? "true" : "false");
      formData.append("owner_email", ownerEmail.trim());
      formData.append("category_name", fullCategoryName);

      // Append all files to the single formData
      evidenceFiles.forEach((file) => {
        formData.append("evidence_files", file);
      });

      await axios.post(`${API_URL}api/save_smartmap_data/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress({ percentage: percentCompleted, show: true });
        }
      });

      toast.success(t('msg.allEvidenceFilesUploadedSuccess', { ns: 'smart_map', defaultValue: 'All {{count}} evidence file(s) uploaded successfully!', count: evidenceFiles.length }), {
        position: "top-right",
        autoClose: 3000,
      });

      setEvidenceDate("");
      setEvidenceFiles([]);
      setGatheringMethod("");
      setVerified(false);
      setOwnerEmail(caraUser?.email || "");
      setUploadProgress({ percentage: 0, show: false });

      await fetchEvidenceTableData();
    } catch (err) {
      console.error("🔥 Unexpected upload error", err);
      toast.error(t('msg.unexpectedErrorDuringUpload', { ns: 'smart_map', defaultValue: 'An unexpected error occurred during upload.' }), {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsEvidenceSaving(false);
    }
  };

  const handleFileDownload = async (e, url, fileName) => {
    e.preventDefault();
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = cleanFileName(fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
      window.open(url, '_blank');
    }
  };

  // Strip UUID/hex prefix from S3 filenames (e.g. "98c6e9c7ac6f466dadcca0b4_filename.xlsx" or "timestamp_uuid_filename.xlsx" -> "filename.xlsx")
  const cleanFileName = (name) => {
    if (!name) return name;
    // Match optional timestamp prefix + hex string (with or without hyphens, 16+ chars) + underscore at the start
    return name.replace(/^(\d+_)?([a-f0-9-]{16,}_)/i, '');
  };

  // Fetch Existing Evidence Data

  const fetchSmartMapEvidence = useCallback(async () => {

    console.log("Fetching Smart Map evidence for CID:", cid);

    setLoading(true);

    try {

      const res = await axios.get(`${API_URL}api/get_smartmap_data/`, {

        params: { cid },

        withCredentials: true,

      });

      console.log("Smart Map evidence GET response:", res.data);

      setNistData(res.data);

    } catch (err) {

      console.error("Error loading Smart Map evidence:", err);

      setError("Failed to load existing evidence.");

    } finally {

      setLoading(false);

    }

  }, [cid]);



  useEffect(() => {

    if (cid) fetchSmartMapEvidence();

  }, [cid, fetchSmartMapEvidence]);



  // End



  // ================================

  // 📌 Question Response (Auto-Save)

  // ================================



  const [nistQuestionResponses, setNistQuestionResponses] = useState({});



  // Auto-save on response change

  useEffect(() => {

    // Don't run if dataMap hasn't loaded yet

    if (!dataMap) return;



    const timeout = setTimeout(() => {

      const saveToBackend = async () => {

        try {

          const items = dataMap?.[activeButton]?.items || [];

          if (!items.length) return;

          const category = dataMap?.[activeButton]?.category;

          const currentCategoryResponses = nistQuestionResponses[activeButton] || {};

          const questionLookup = {};

          items.forEach(item => {
            const subcategoryName = item.subcategory || item.heading || "General";
            (item.questions || []).forEach(question => {
              const cleanId = question?.categoryid?.replace(/:$/, "");
              if (!cleanId) return;
              questionLookup[cleanId] = {
                question,
                subcategoryName,
                item,
              };
            });
          });

          const subcategoryMap = {};

          Object.entries(currentCategoryResponses)

            .filter(([_, val]) => val.notes || val.priority || val.status)

            .forEach(([categoryid, values]) => {

              const cleanedCategoryId = categoryid.replace(/:$/, "");

              const meta = questionLookup[cleanedCategoryId];

              if (!meta) {

                console.warn(`No Smart Map question metadata found for category_id: ${cleanedCategoryId}`);

                return;

              }

              const { question: questionObj, subcategoryName, item } = meta;

              if (!subcategoryMap[subcategoryName]) {

                subcategoryMap[subcategoryName] = [];

              }

              const questionData = {

                category_id: cleanedCategoryId,

                question: questionObj?.question,

                task: questionObj?.task || item?.task || "",

                priority: values.priority || "High",

                notes: values.notes || "",

                status: values.status || "In Practice",

                evidence: values.evidence || "",

                examples: values.examples || "",

              };

              const existingIndex = subcategoryMap[subcategoryName].findIndex(

                q => q.category_id === cleanedCategoryId

              );

              if (existingIndex !== -1) {

                subcategoryMap[subcategoryName][existingIndex] = questionData;

              } else {

                subcategoryMap[subcategoryName].push(questionData);

              }

            });

          if (Object.keys(subcategoryMap).length === 0) return;

          const payload = {

            cid: cid, // Add this line to send cid           

            categories: {

              [category]: {

                subcategories: Object.entries(subcategoryMap).map(([subcategory_name, questions]) => ({

                  subcategory_name,

                  questions,

                })),

              },

            },

          };

          console.log("🚀 Payload:", JSON.stringify(payload, null, 2));

          const res = await axios.post(`${API_URL}api/save_smartmap_data/`, payload, {

            headers: { "Content-Type": "application/json" },

            withCredentials: true,

          });

          console.log("Auto-saved Smart Map data", res.data);



        } catch (err) {

          console.error("🔥 Save failed", err);

        }

      };

      if (Object.keys(nistQuestionResponses[activeButton] || {}).length > 0) {

        saveToBackend();

      }

    }, 1000);

    return () => clearTimeout(timeout);

  }, [nistQuestionResponses, activeButton, openCardIndex, dataMap, cid]);





  // ================================

  //  Load Existing Responses

  // ================================



  // useEffect(() => {

  //   const fetchSavedResponses = async () => {

  //     try {

  //       const queryParams = new URLSearchParams(window.location.search);

  //       const cid = queryParams.get("cid");



  //       if (!cid) {

  //         console.warn("CID not found in URL");

  //         return;

  //       }



  //       const res = await axios.get(`${API_URL}api/save_assessment/nist_csf_2_0/`, {

  //         params: {

  //           cid

  //         },

  //         headers: { "Content-Type": "application/json" },

  //         withCredentials: true,

  //       });





  //       const data = res.data;

  //       if (!data?.categories) {

  //         console.warn("No categories found in response");

  //         return;

  //       }



  //       const formattedResponses = {};

  //       const newActivePriority = {};

  //       const newActiveStatus = {};



  //       Object.entries(data.categories).forEach(([categoryName, category]) => {

  //         if (!category.subcategories) return;



  //         category.subcategories.forEach(subcategory => {

  //           if (!subcategory.questions) return;



  //           subcategory.questions.forEach(question => {

  //             const cleanedId = question.category_id?.replace(/:$/, "");

  //             if (!cleanedId) return;



  //             if (!formattedResponses[activeButton]) {

  //               formattedResponses[activeButton] = {};

  //               newActivePriority[activeButton] = {};

  //               newActiveStatus[activeButton] = {};

  //             }



  //             formattedResponses[activeButton][cleanedId] = {

  //               priority: question.priority || "",

  //               notes: question.notes || "",

  //               status: question.status || "",

  //               evidence: question.evidence || "",

  //               examples: question.examples || "",

  //             };



  //             newActivePriority[activeButton][cleanedId] = question.priority || "High";

  //             newActiveStatus[activeButton][cleanedId] = question.status || "In Practice";

  //           });

  //         });

  //       });



  //       console.log("Parsed fetched data:", formattedResponses);

  //       setNistQuestionResponses(formattedResponses);

  //       setActivePriority(newActivePriority);

  //       setActiveStatus(newActiveStatus);

  //     } catch (error) {

  //       console.error("🔥 Error fetching responses:", error.response?.data || error.message);

  //     }

  //   };



  //   if (openCardIndex !== null && dataMap[activeButton]) {

  //     fetchSavedResponses();

  //   }

  // }, [openCardIndex, activeButton]);



  // Auto-save Pre-filled data to database function

  const autoSavePrefilledDataToDB = useCallback(async (formattedResponses, preFillValues) => {

    try {

      const queryParams = new URLSearchParams(window.location.search);

      const cid = queryParams.get("cid");



      if (!cid) {

        console.warn("CID not found for auto-save");

        return;

      }



      // Build the payload for all categories

      const categoriesPayload = {};



      Object.keys(dataMap || {}).forEach((categoryKey) => {

        const category = dataMap[categoryKey]?.category;

        if (!category) return;



        const subcategoryMap = {};

        const categoryResponses = formattedResponses[categoryKey] || {};



        dataMap[categoryKey]?.items?.forEach((item) => {

          const subcategoryName = item.subcategory || "General";

          if (!subcategoryMap[subcategoryName]) {

            subcategoryMap[subcategoryName] = [];

          }



          item.questions.forEach((question) => {

            const cleanedId = question.categoryid?.replace(/:$/, "");

            if (cleanedId && categoryResponses[cleanedId]) {

              const questionData = {

                category_id: cleanedId,

                question: question.question,

                task: question.task || item.task || "",

                priority: categoryResponses[cleanedId].priority || preFillValues.priority,

                notes: categoryResponses[cleanedId].notes || "",

                status: categoryResponses[cleanedId].status || preFillValues.status,

                evidence: categoryResponses[cleanedId].evidence || "",

                examples: categoryResponses[cleanedId].examples || "",

              };

              subcategoryMap[subcategoryName].push(questionData);

            }

          });

        });



        if (Object.keys(subcategoryMap).length > 0) {

          categoriesPayload[category] = {

            subcategories: Object.entries(subcategoryMap).map(([subcategory_name, questions]) => ({

              subcategory_name,

              questions,

            })),

          };

        }

      });



      if (Object.keys(categoriesPayload).length === 0) {

        console.warn("No data to auto-save");

        return;

      }



      const payload = {

        cid: cid,

        categories: categoriesPayload,

      };



      console.log("🚀 Auto-saving Pre-filled payload to database:", JSON.stringify(payload, null, 2));



      const res = await axios.post(`${API_URL}api/save_smartmap_data/`, payload, {

        headers: { "Content-Type": "application/json" },

        withCredentials: true,

      });



      console.log("Pre-filled Smart Map data auto-saved to database successfully:", res.data);



    } catch (error) {

      console.error("🔥 Error auto-saving Pre-filled data to database:", error.response?.data || error.message);

    }

  }, [dataMap]);



  // Load existing responses or apply pre-filled values

  useEffect(() => {

    const fetchSavedResponses = async () => {

      try {

        const queryParams = new URLSearchParams(window.location.search);

        const cid = queryParams.get("cid");



        if (!cid) {

          console.warn("CID not found in URL");

          return;

        }



        const res = await axios.get(`${API_URL}api/get_smartmap_data/?cid=${cid}`, {

          headers: { "Content-Type": "application/json" },

          withCredentials: true,

        });



        const data = res.data;

        const isPrefilled = assessment?.assessment_type === "Pre-filled Data"; // Check if assessment is Pre-filled Data

        const userIndustry = caraUser?.industry || "Default"; // Get industry from caraUser, fallback to "Default"

        const preFillValues = industryPreFillMapNist[userIndustry] || { priority: "Medium", status: "Partially Implemented" }; // Fallback defaults



        if (!data?.categories) {

          console.warn("No categories found in response");

          // If Pre-filled and no data, initialize with pre-filled values

          if (isPrefilled) {

            const formattedResponses = {};

            const newActivePriority = {};

            const newActiveStatus = {};



            // Iterate through all categories in dataMap

            Object.keys(dataMap || {}).forEach((categoryKey) => {

              formattedResponses[categoryKey] = {};

              newActivePriority[categoryKey] = {};

              newActiveStatus[categoryKey] = {};



              dataMap[categoryKey]?.items?.forEach((item) => {

                item.questions.forEach((question) => {

                  const cleanedId = question.categoryid?.replace(/:$/, "");

                  if (cleanedId) {

                    formattedResponses[categoryKey][cleanedId] = {

                      priority: preFillValues.priority,

                      status: preFillValues.status,

                      notes: "",

                      evidence: "",

                      examples: "",

                    };

                    newActivePriority[categoryKey][cleanedId] = preFillValues.priority;

                    newActiveStatus[categoryKey][cleanedId] = preFillValues.status;

                  }

                });

              });

            });



            setNistQuestionResponses(formattedResponses);

            setActivePriority(newActivePriority);

            setActiveStatus(newActiveStatus);



            // Auto-save Pre-filled data to database immediately (without waiting for all data)

            console.log("🚀 Auto-saving Pre-filled data to database (no existing data)...");

            autoSavePrefilledDataToDB(formattedResponses, preFillValues);

          }

          return;

        }



        const formattedResponses = {};

        const newActivePriority = {};

        const newActiveStatus = {};



        // Process existing responses

        Object.entries(data.categories).forEach(([categoryName, category]) => {

          if (!category.subcategories) return;



          category.subcategories.forEach((subcategory) => {

            if (!subcategory.questions) return;



            subcategory.questions.forEach((question) => {

              const cleanedId = question.category_id?.replace(/:$/, "");

              if (!cleanedId) return;



              if (!formattedResponses[activeButton]) {

                formattedResponses[activeButton] = {};

                newActivePriority[activeButton] = {};

                newActiveStatus[activeButton] = {};

              }



              formattedResponses[activeButton][cleanedId] = {

                priority: question.priority || (isPrefilled ? preFillValues.priority : ""),

                status: question.status || (isPrefilled ? preFillValues.status : ""),

                notes: question.notes || "",

                evidence: question.evidence || "",

                examples: question.examples || "",

              };



              newActivePriority[activeButton][cleanedId] =

                question.priority || (isPrefilled ? preFillValues.priority : "High");

              newActiveStatus[activeButton][cleanedId] =

                question.status || (isPrefilled ? preFillValues.status : "In Practice");

            });

          });

        });



        // If Pre-filled, fill in any missing questions with industry-based defaults

        if (isPrefilled) {

          Object.keys(dataMap || {}).forEach((categoryKey) => {

            if (!formattedResponses[categoryKey]) {

              formattedResponses[categoryKey] = {};

              newActivePriority[categoryKey] = {};

              newActiveStatus[categoryKey] = {};

            }



            dataMap[categoryKey]?.items?.forEach((item) => {

              item.questions.forEach((question) => {

                const cleanedId = question.categoryid?.replace(/:$/, "");

                if (cleanedId && !formattedResponses[categoryKey][cleanedId]) {

                  formattedResponses[categoryKey][cleanedId] = {

                    priority: preFillValues.priority,

                    status: preFillValues.status,

                    notes: "",

                    evidence: "",

                    examples: "",

                  };

                  newActivePriority[categoryKey][cleanedId] = preFillValues.priority;

                  newActiveStatus[categoryKey][cleanedId] = preFillValues.status;

                }

              });

            });

          });

        }



        console.log("Parsed fetched data:", formattedResponses);

        setNistQuestionResponses(formattedResponses);

        setActivePriority(newActivePriority);

        setActiveStatus(newActiveStatus);



        // For Pre-filled assessments, auto-save data to database

        if (isPrefilled) {

          // Auto-save Pre-filled data to database immediately (without waiting for all data)

          console.log("🚀 Auto-saving Pre-filled data to database...");

          autoSavePrefilledDataToDB(formattedResponses, preFillValues);

        }



      } catch (error) {

        console.error("🔥 Error fetching responses:", error.response?.data || error.message);

        // If Pre-filled and error occurs, initialize with defaults

        if (assessment?.assessment_type === "Pre-filled Data") {

          const userIndustry = caraUser?.industry || "Default";

          const preFillValues = industryPreFillMapNist[userIndustry] || { priority: "Medium", status: "Partially Implemented" };



          const formattedResponses = {};

          const newActivePriority = {};

          const newActiveStatus = {};



          Object.keys(dataMap || {}).forEach((categoryKey) => {

            formattedResponses[categoryKey] = {};

            newActivePriority[categoryKey] = {};

            newActiveStatus[categoryKey] = {};



            dataMap[categoryKey]?.items?.forEach((item) => {

              item.questions.forEach((question) => {

                const cleanedId = question.categoryid?.replace(/:$/, "");

                if (cleanedId) {

                  formattedResponses[categoryKey][cleanedId] = {

                    priority: preFillValues.priority,

                    status: preFillValues.status,

                    notes: "",

                    evidence: "",

                    examples: "",

                  };

                  newActivePriority[categoryKey][cleanedId] = preFillValues.priority;

                  newActiveStatus[categoryKey][cleanedId] = preFillValues.status;

                }

              });

            });

          });
          setNistQuestionResponses(formattedResponses);

          setActivePriority(newActivePriority);

          setActiveStatus(newActiveStatus);
          // Auto-save Pre-filled data to database immediately (without waiting for all data)

          console.log("🚀 Auto-saving Pre-filled data to database (error case)...");

          autoSavePrefilledDataToDB(formattedResponses, preFillValues);

        }

      }

    };
    if (openCardIndex !== null && dataMap?.[activeButton]) {

      fetchSavedResponses();

    }

  }, [openCardIndex, activeButton, cid, caraUser, assessment, dataMap, autoSavePrefilledDataToDB]); // Added dataMap to dependencies  
  // ================================

  // ✏️ Update Question Response

  // ================================



  const updateQuestionResponse = (categoryid, field, value) => {

    setNistQuestionResponses(prev => ({

      ...prev,

      [activeButton]: {

        ...(prev[activeButton] || {}),

        [categoryid]: {

          ...(prev[activeButton]?.[categoryid] || {}),

          [field]: value,

        },

      },

    }));



    if (field === "priority") {

      setActivePriority(prev => ({

        ...prev,

        [activeButton]: {

          ...(prev[activeButton] || {}),

          [categoryid]: value,

        },

      }));

      // Check if Reset Button should be enabled

      setTimeout(() => checkIfAnyDataFilled(), 100);

    }



    if (field === "status") {

      setActiveStatus(prev => ({

        ...prev,

        [activeButton]: {

          ...(prev[activeButton] || {}),

          [categoryid]: value,

        },

      }));

      // Show toast notification for status change

      // Check if Reset Button should be enabled

      setTimeout(() => checkIfAnyDataFilled(), 100);

    }

  };



  // ================================

  //  Rendering Preparation & Guard

  // ================================



  // if (!Array.isArray(dataMap[activeButton]?.items)) {

  //   return <div>No items found</div>;

  // }



  // const selectedItem = dataMap[activeButton].items[activeItem];



  // ================================

  //  Filled Count per Category - removed

  // ================================



  // Reset Data

  const handleResetAllData = async () => {

    if (!cid) {

      alert(t('msg.cidMissingFromUrl', { ns: 'framework_common', defaultValue: 'CID is missing from URL.' }));

      return;

    }

    try {
      // Use the existing DELETE API which now handles data, tasks and assessment_type reset
      const response = await axios.delete(`${API_URL}api/delete_smartmap_data/?cid=${cid}`, {
        withCredentials: true,
      });

      if (response.data.status === "SUCCESS") {
        toast.success(t('msg.frameworkResetSuccessfully', { ns: 'framework_common', defaultValue: 'Framework Data Reset Successfully' }));
        setIsResetEnabled(false);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(t('msg.failedToResetDataWithMessage', { ns: 'smart_map', defaultValue: 'Failed to reset data: {{message}}', message: response.data.message }));
      }
    } catch (error) {
      console.error("Error resetting data:", error);
      toast.error(t('msg.failedToResetDataRetry', { ns: 'framework_common', defaultValue: 'Failed to reset data. Please try again.' }));
    }

  };













  // End



  const handleComplianceTracker = () => {

    const control = 'Smart Map';

    const scope = assessment?.scope || '';

    navigate(`/compliance_tracker_framework?cid=${cid}&control=${control}&scope=${scope}`);

  };



  // ========================================================================================//



  // Show loading/error states for framework data (before return)

  if (frameworkLoading) {

    return (

      <div className="container mt-5 text-center">

        <div className="spinner-border text-primary" role="status">

          <span className="visually-hidden">{t('msg.loadingSmartMapFrameworkVisuallyHidden', { ns: 'smart_map', defaultValue: 'Loading Smart Map framework...' })}</span>

        </div>

        <p className="mt-3">{t('msg.loadingFrameworkData', { ns: 'framework_common', defaultValue: 'Loading {{framework}} framework data...', framework: 'Smart Map' })}</p>

      </div>

    );

  }



  if (frameworkError) {

    return (

      <div className="container mt-5">

        <div className="alert alert-danger" role="alert">

          <h4 className="alert-heading">{t('title.errorLoadingFramework', { ns: 'framework_common', defaultValue: 'Error Loading Framework' })}</h4>

          <p>{frameworkError}</p>

          <hr />

          <button className="btn btn-primary" onClick={refetchFramework}>

            {t('btn.retryEmoji', { ns: 'smart_map', defaultValue: ' Retry' })}

          </button>

        </div>

      </div>

    );

  }



  if (!dataMap || !contentMap || !dataMapData) {

    return (

      <div className="container mt-5">

        <div className="alert alert-warning">{t('msg.frameworkDataNotAvailable', { ns: 'framework_common', defaultValue: 'Framework data not available' })}</div>

      </div>

    );

  }



  return (

    <div className='content-wrapper'>

      <main className="app-main" id="cyber_program_scope"> {/*begin::App Content Header*/}

        {/* Cyber Program Scope Start */}

        <div className="content-header"> {/*begin::Container*/}

          <div className="container-fluid"> {/*begin::Row*/}

            <div className="row mt-0">

              <div className="col-sm-3">

                <h5 className="mb-2 text-primary fs-5">{t('title.cyberProgramScopeAllCaps', { ns: 'smart_map', defaultValue: 'CYBER PROGRAM SCOPE' })} </h5>

                {assessment && (

                  <div className="assessment-details">

                    <h3 className="mb-2 colour-black fs-5">{assessment.framework || ''} <span className="colour-black">2.0</span></h3>

                    <h3 className="mb-2  colour-black fs-5 center">{assessment.scope || ''}</h3>

                  </div>

                )}

              </div>





              <div className="col-sm-9">

                {/*begin::Top CTA's */}

                <div className="container">

                  <div className="row g-3 align-items-center">



                    {/* Reset Button */}

                    <div className="col-6 col-md-3">

                      <button

                        className="fw-bold btn btn-primary btn-sm w-100 rounded px-4 py-2"

                        type="button"

                        data-bs-toggle="modal"

                        data-bs-target="#resetProfile"

                        disabled={!isResetEnabled}

                        style={{

                          opacity: isResetEnabled ? 1 : 0.6,

                          cursor: isResetEnabled ? 'pointer' : 'not-allowed'

                        }}

                      >

                        {t('btn.reset', { ns: 'framework_common', defaultValue: 'Reset' })} {isResetEnabled}

                      </button>

                    </div>

                    {/* Reset Modal */}

                    <div

                      className="modal fade"

                      id="resetProfile"

                      tabIndex="-1"

                      aria-labelledby="resetProfileLabel"

                      aria-hidden="true"

                      ref={resetProfileRef}

                    >

                      <div className="modal-dialog modal-lg modal-dialog-custom" role="document">

                        <div className="modal-content border-0 modal-content-custom">

                          <div className="modal-header modal-header-custom">

                            <h5 className="modal-title fw-bold" id="resetProfileLabel">

                              {t('title.resetProfile', { ns: 'framework_common', defaultValue: 'Reset Profile' })}

                            </h5>

                            <button type="button" className="close text-white" data-bs-dismiss="modal" aria-label={t('btn.close', { ns: 'common', defaultValue: 'Close' })}>

                              <span aria-hidden="true">&times;</span>

                            </button>

                          </div>

                          <div className="modal-body fs-6 text-secondary fw-semibold">

                            {t('msg.resetProfileConfirm', { ns: 'framework_common', defaultValue: 'Are you sure you want to restore the Non-Intrusive Cybersecurity Framework Assessment original framework? By clicking Reset it will permanently delete all the saved data. Please save a copy by downloading it.' })}

                          </div>

                          <div className="modal-footer justify-content-end">

                            <button

                              type="button"

                              className="btn btn-success px-4 py-2 rounded-pill"

                              onClick={handleResetAllData}

                              data-bs-dismiss="modal"

                            >

                              {t('btn.reset', { ns: 'framework_common', defaultValue: 'Reset' })}

                            </button>







                            <button

                              type="button"

                              className="btn btn-danger px-4 py-2 rounded-pill"

                              data-bs-dismiss="modal"

                            >

                              {t('btn.cancel', { ns: 'common', defaultValue: 'Cancel' })}

                            </button>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* Controls Dropdown */}

                    <div className="col-6 col-md-3" ref={dropdownRef}>

                      <div className="dropdown w-100">

                        <button

                          className="fw-bold btn btn-secondary btn-sm w-100 rounded px-4 py-2 dropdown-toggle text-white"

                          type="button"

                          onClick={() => setShowControlsDropdown(!showControlsDropdown)}

                        >

                          {t('dropdown.controls', { ns: 'framework_common', defaultValue: 'Controls' })}

                        </button>

                        {showControlsDropdown && (

                          <div className="dropdown-menu show w-100">

                            <button type="button" className="dropdown-item" onClick={handleControlsPdfDownloadClick}>{t('option.pdf', { ns: 'framework_common', defaultValue: 'PDF' })}</button>

                            <button type="button" className="dropdown-item" onClick={handleControlsExcelDownload}>{t('option.excelSheet', { ns: 'framework_common', defaultValue: 'Excel-Sheet' })}</button>

                          </div>

                        )}

                      </div>

                    </div>



                    {/* Verified Evidences Dropdown */}

                    <div className="col-6 col-md-3" ref={evidenceRef}>

                      <div className="dropdown w-100">

                        <button

                          className="fw-bold btn btn-secondary btn-sm w-100 rounded px-4 py-2 dropdown-toggle text-white"

                          type="button"

                          onClick={() => setShowEvidenceDropdown(!showEvidenceDropdown)}

                        >

                          {t('dropdown.verifiedEvidences', { ns: 'framework_common', defaultValue: 'Verified Evidences' })}

                        </button>

                        {showEvidenceDropdown && (

                          <div className="dropdown-menu show w-100">

                            <button type="button" className="dropdown-item" onClick={handleEvidencePdfDownloadClick}>{t('option.pdf', { ns: 'framework_common', defaultValue: 'PDF' })}</button>

                            <button type="button" className="dropdown-item" onClick={handleEvidenceExcelDownload}>{t('option.excelSheet', { ns: 'framework_common', defaultValue: 'Excel-Sheet' })}</button>

                          </div>

                        )}

                      </div>

                    </div>

                  </div>

                </div>





                {/* ⬇️ Add this for vertical gap */}

                <div className="row my-1">

                  <div className="col-12"></div> {/* Empty row with vertical spacing */}

                </div>





                {/*end::Top CTA's */} {/*end::Row*/}

                <div className="row ms-0">

                  <div className="col-md-12 d-flex align-items-start flex-wrap gap-3">

                    {/* Priority Field */}

                    <div className="d-flex flex-column">

                      <div className="d-flex gap-3 flex-wrap">



                        {/* Q Priority */}

                        <div className="text-center">

                          <label className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '1rem' }}>

                            <i className="bi bi-search text-secondary" />

                            {t('label.priority', { ns: 'framework_common', defaultValue: 'Priority' })}:

                          </label>

                          <div className="position-relative" style={{ width: "150px" }}>

                            <select

                              id="priorityFilterSelect"

                              value={priorityFilter}

                              onChange={(e) => setPriorityFilter(e.target.value)}

                              className="form-control border-2 rounded-3"

                              style={dropdownStyle}

                            >

                              <option value="All">{t('option.all', { ns: 'framework_common', defaultValue: 'All' })}</option>

                              <option value="High">{t('priority.high', { ns: 'framework_common', defaultValue: 'High' })}</option>

                              <option value="Medium">{t('priority.medium', { ns: 'framework_common', defaultValue: 'Medium' })}</option>

                              <option value="Low">{t('priority.low', { ns: 'framework_common', defaultValue: 'Low' })}</option>

                            </select>

                            <i className="fa fa-chevron-down position-absolute" style={chevronStyle}></i>

                          </div>

                        </div>



                        {/* Q Current Posture */}

                        <div className="text-center">

                          <label className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '1rem' }}>

                            <i className="bi bi-search text-secondary" />

                            {t('label.currentPosture', { ns: 'framework_common', defaultValue: 'Current Posture' })}:

                          </label>

                          <div className="position-relative" style={{ width: "180px" }}>

                            <select

                              id="postureFilterSelect"

                              value={postureFilter}

                              onChange={(e) => setPostureFilter(e.target.value)}

                              className="form-control border-2 rounded-3"

                              style={dropdownStyle}

                            >

                              <option value="All">{t('option.all', { ns: 'framework_common', defaultValue: 'All' })}</option>

                              <option value="In Practice">{t('status.inPractice', { ns: 'framework_common', defaultValue: 'In Practice' })}</option>

                              <option value="Fully Implemented">{t('status.fullyImplemented', { ns: 'framework_common', defaultValue: 'Fully Implemented' })}</option>

                              <option value="Largely Implemented">{t('status.largelyImplemented', { ns: 'framework_common', defaultValue: 'Largely Implemented' })}</option>

                              <option value="Partially Implemented">{t('status.partiallyImplemented', { ns: 'framework_common', defaultValue: 'Partially Implemented' })}</option>

                              <option value="Not Implemented">{t('status.notImplemented', { ns: 'framework_common', defaultValue: 'Not Implemented' })}</option>

                              <option value="Not Applicable">{t('status.notApplicable', { ns: 'framework_common', defaultValue: 'Not Applicable' })}</option>

                            </select>

                            <i className="fa fa-chevron-down position-absolute" style={chevronStyle}></i>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* Clear + Toggle */}

                    <div className="d-flex flex-column align-items-start">

                      <label className="invisible mb-1">.</label> {/* Invisible label to align vertically */}

                      <div className="d-flex gap-2 align-items-center" style={{ alignSelf: 'flex-end' }}>

                        <button

                          className="btn text-danger bg-danger-subtle rounded-3 px-3"

                          style={{

                            height: '35px',

                            fontSize: '0.875rem',

                            marginTop: '-4px'

                          }}

                          type="button"

                          onClick={clearFiltersfilter} // Make sure this function is defined in your component

                        >

                          {t('btn.clear', { ns: 'framework_common', defaultValue: 'Clear' })}

                        </button>

                        <div className="toggle-btn d-flex align-items-center">

                          <input

                            type="radio"

                            className="btn-check"

                            name="viewToggle"

                            id="currentView"

                            autoComplete="off"

                            defaultChecked

                          />

                          <label

                            className="btn btn-outline-success rounded-start-pill fw-bold"

                            htmlFor="currentView"

                            style={{

                              height: '35px',

                              padding: '6px 20px',

                              fontSize: '0.875rem'

                            }}

                          >

                            {t('label.current', { ns: 'framework_common', defaultValue: 'Current' })}

                          </label>

                          <input

                            type="radio"

                            className="btn-check"

                            name="viewToggle"

                            id="targetView"

                            autoComplete="off"

                          />

                          <label

                            className="btn btn-outline-success rounded-end-pill fw-bold"

                            htmlFor="targetView"

                            style={{

                              height: '35px',

                              padding: '6px 20px',

                              fontSize: '0.875rem'

                            }}

                          >

                            {t('label.target', { ns: 'framework_common', defaultValue: 'Target' })}

                          </label>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

                {/*end::Row*/}

              </div>

            </div> {/*end::Row*/}

            <hr />

            <div className="container-fluid py-0" style={{ backgroundColor: "#F0F2FF", borderRadius: "10px" }}>

              <div className="container-fluid py-0 border">

                <div className="row g-4 main-cards">

                  <div className="col-lg-12">

                    <div className="row p-3">

                      <div className="container-fluid">

                        <div className="row mb-3">

                          <div className="col-12 d-flex justify-content-end align-items-center">

                            {/* Compliance Tracker Button */}

                            <button

                              type="button"

                              className="btn btn-primary py-1 px-3 fw-semibold"

                              onClick={handleComplianceTracker}

                            >

                              {t('btn.complianceTracker', { ns: 'framework_common', defaultValue: 'Compliance Tracker' })}

                            </button>

                          </div>

                        </div>





                      </div>

                      {/* <div className="mb-3">

                                {/* Add scroll to the card container */}

                      <div
                        ref={questionsContainerRef}
                        className="row"
                        style={{
                          maxHeight: '350px',
                          minHeight: '100vh',
                          overflowY: 'scroll',

                        }}

                      >

                        {/* Using the map function  */}

                        {/* Cards Rendering Main Logic */}



                        {dataMap[activeButton]?.items?.flatMap((item, itemIndex) =>
                          item.questions || []
                        )

                          .filter((q) => {

                            const cleanCategoryId = q.categoryid.replace(/:$/, "");

                            const selectedPriority = activePriority?.[activeButton]?.[cleanCategoryId];

                            const selectedPosture = activeStatus?.[activeButton]?.[cleanCategoryId];



                            const priorityMatch =

                              !priorityFilter || priorityFilter === "All" || selectedPriority === priorityFilter;

                            const postureMatch =

                              !postureFilter || postureFilter === "All" || selectedPosture === postureFilter;



                            const comboPriorityMatch =

                              !comboPriorityFilter || selectedPriority === comboPriorityFilter;

                            const comboPostureMatch =

                              !comboPostureFilter || selectedPosture === comboPostureFilter;



                            return priorityMatch && postureMatch && comboPriorityMatch && comboPostureMatch;

                          })

                          .map((q, index) => {

                            const cleanCategoryId = q.categoryid.replace(/:$/, "");

                            const response = nistQuestionResponses?.[activeButton]?.[cleanCategoryId] || {};

                            const isPrioritySelected = !!response.priority;

                            const isStatusFilled = !!response.status?.trim();

                            const isNotApplicable = response.status === "Not Applicable";

                            const enableButtons = isPrioritySelected && isStatusFilled && !isNotApplicable;

                            const hasEvidence = evidenceIdsSet.has(cleanCategoryId);




                            return (

                              <div className="col-12 mb-0" key={index}>

                                <div className="card">

                                  <div className="d-flex justify-content-between align-items-center mb-2">

                                    <div className="col-lg-10">

                                      <div className="row">

                                        <div className="d-flex align-items-center justify-content-center ">

                                          <div className="d-flex align-items-center justify-content-start w-100">                                                                                                      <div className="container-fluid py-0" style={{ borderRadius: '10px' }}>

                                            <div className="card-body text-start header-title ">

                                              {/* First Line: Control ID Badges on Left, Metadata on Right */}
                                              <div className="d-flex align-items-center justify-content-between mb-2">

                                                {/* Left Side: Control ID Badges */}
                                                <div className="d-flex gap-2" style={{ justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: 'center' }}>

                                                  {/* Common Control ID Badge - Green */}
                                                  {q.commonControlId && (
                                                    <div
                                                      className="text-center border-0 rounded p-1 text-white"
                                                      style={{
                                                        backgroundColor: '#28A745',
                                                        minWidth: '130px',
                                                        textAlign: 'center',
                                                        fontSize: '15px',
                                                        marginLeft: '-30px',
                                                        padding: '6px 10px',
                                                      }}
                                                      title={t('tooltip.commonControlId', { ns: 'smart_map', defaultValue: 'Common Control ID: {{id}}', id: q.commonControlId })}
                                                    >
                                                      <strong>{q.commonControlId}</strong>
                                                    </div>
                                                  )}

                                                  {/* NIST Badge - Purple */}
                                                  <div

                                                    className="text-center border-0 rounded p-1 text-white"

                                                    style={{

                                                      backgroundColor: '#7B68EE',

                                                      minWidth: '110px',

                                                      textAlign: 'center',

                                                      fontSize: '14px',

                                                      padding: '6px 10px',

                                                    }}

                                                    title={t('tooltip.nistCsf20WithId', { ns: 'smart_map', defaultValue: 'NIST CSF 2.0: {{id}}', id: q.categoryid })}

                                                  >

                                                    <strong>{t('label.nistBadgePrefix', { ns: 'smart_map', defaultValue: 'NIST:' })} {q.categoryid}</strong>

                                                  </div>

                                                  {/* ISO Badge - Blue */}
                                                  {q.isoControls && Array.isArray(q.isoControls) && q.isoControls.length > 0 && (
                                                    <div
                                                      className="text-center border-0 rounded p-1 text-white"
                                                      style={{
                                                        backgroundColor: '#4A90E2',
                                                        minWidth: '100px',
                                                        textAlign: 'center',
                                                        fontSize: '14px',
                                                        padding: '6px 10px',
                                                      }}
                                                      title={t('tooltip.isoAnnexAWithIds', { ns: 'smart_map', defaultValue: 'ISO 27001:2022 Annex A: {{ids}}', ids: q.isoControls.join(', ') })}
                                                    >
                                                      <strong>{t('label.isoBadgePrefix', { ns: 'smart_map', defaultValue: 'ISO:' })} {q.isoControls.join(', ')}</strong>
                                                    </div>
                                                  )}

                                                  {/* CIS Badge - Orange */}
                                                  {q.cisControls && Array.isArray(q.cisControls) && q.cisControls.length > 0 && (
                                                    <div
                                                      className="text-center border-0 rounded p-1 text-white"
                                                      style={{
                                                        backgroundColor: '#F39C12',
                                                        minWidth: '100px',
                                                        textAlign: 'center',
                                                        fontSize: '14px',
                                                        padding: '6px 10px',
                                                      }}
                                                      title={t('tooltip.cisControlsV8WithIds', { ns: 'smart_map', defaultValue: 'CIS Controls v8: {{ids}}', ids: q.cisControls.join(', ') })}
                                                    >
                                                      <strong>{t('label.cisBadgePrefix', { ns: 'smart_map', defaultValue: 'CIS:' })} {q.cisControls.join(', ')}</strong>
                                                    </div>
                                                  )}

                                                </div>

                                                {/* Right Side: Metadata Badges */}
                                                <div className="d-flex gap-3" style={{ justifyContent: 'flex-end', alignItems: 'flex-start', flexShrink: 0 }}>

                                                  {/* Mapping Strength Badge - Teal */}
                                                  {q.mappingStrength && (
                                                    <div className="d-flex flex-column align-items-center">
                                                      <span style={{ fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>{t('label.mappingStrengthBadge', { ns: 'smart_map', defaultValue: 'Mapping Strength' })}</span>
                                                      <div
                                                        className="text-center border-0 rounded p-1 text-white"
                                                        style={{
                                                          backgroundColor: '#17A2B8',
                                                          minWidth: '90px',
                                                          textAlign: 'center',
                                                          fontSize: '13px',
                                                          padding: '6px 10px',
                                                        }}
                                                        title={t('tooltip.mappingStrengthWithValue', { ns: 'smart_map', defaultValue: 'Mapping Strength: {{value}}', value: q.mappingStrength })}
                                                      >
                                                        <strong>{q.mappingStrength}</strong>
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* Evidence Type Badge - Dark Gray */}
                                                  {q.evidenceType && (
                                                    <div className="d-flex flex-column align-items-center">
                                                      <span style={{ fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>{t('label.evidenceTypeBadge', { ns: 'smart_map', defaultValue: 'Evidence Type' })}</span>
                                                      <div
                                                        className="text-center border-0 rounded p-1 text-white"
                                                        style={{
                                                          backgroundColor: '#6C757D',
                                                          minWidth: '90px',
                                                          textAlign: 'center',
                                                          fontSize: '13px',
                                                          padding: '6px 10px',
                                                        }}
                                                        title={t('tooltip.evidenceTypeWithValue', { ns: 'smart_map', defaultValue: 'Evidence Type: {{value}}', value: q.evidenceType })}
                                                      >
                                                        <strong>{q.evidenceType}</strong>
                                                      </div>
                                                    </div>
                                                  )}

                                                </div>

                                              </div>

                                              {/* Second Line: Question Text */}
                                              <div className="mb-2" style={{ marginLeft: '-30px' }}>

                                                <h6 className="m-0" style={{ fontSize: '15px' }}>

                                                  {q.question}

                                                </h6>

                                              </div>

                                            </div>

                                          </div>

                                          </div>

                                        </div>

                                      </div>

                                      <div className="row mb-2">

                                        <div className="col-lg-5">

                                          <label>{t('label.priority', { ns: 'framework_common', defaultValue: 'Priority' })} :</label>

                                          <div className="row mt-2">

                                            {/* Buttons and Color Logic*/}

                                            <div className="col d-flex justify-content-start">

                                              {priority.map((level) => (

                                                <button

                                                  key={level}

                                                  type="button"

                                                  className="btn toggle-btn text-white fw-bold me-2"

                                                  style={{

                                                    width: "85px",

                                                    padding: "4px 8px",

                                                    fontSize: "14px",

                                                    backgroundColor: activePriority?.[activeButton]?.[cleanCategoryId] === level ? "#736DD5" : "#6c757d",

                                                    color: "#FFFFFF",

                                                    borderRadius: "12px",

                                                    border: activePriority?.[activeButton]?.[cleanCategoryId] === level ? "2px solid #2D2A66" : "none",

                                                    boxShadow: activePriority?.[activeButton]?.[cleanCategoryId] === level ? "0 0 8px rgba(115, 109, 213, 0.6)" : "none",

                                                  }}

                                                  onClick={() => updateQuestionResponse(cleanCategoryId, "priority", level)}
                                                  disabled={isNotApplicable}

                                                >

                                                  {t(priorityLabelKeys[level], { ns: 'framework_common', defaultValue: level })}

                                                </button>

                                              ))}

                                            </div>

                                          </div>

                                        </div>

                                        <div className="col-lg-7">

                                          <label className="form-label">{t('label.notes', { ns: 'framework_common', defaultValue: 'Notes' })}:</label>

                                          <textarea

                                            className="form-control"

                                            value={nistQuestionResponses?.[activeButton]?.[cleanCategoryId]?.notes || ""}

                                            onChange={(e) =>

                                              updateQuestionResponse(cleanCategoryId, "notes", e.target.value)

                                            }

                                          />

                                        </div>

                                      </div>

                                    </div>
                                    <div className="col-lg-2 d-flex flex-column mt-2" style={{ position: 'relative' }}>
                                      <div className="d-flex flex-column align-items-center gap-2" style={{ width: '100%', padding: '0 10px', boxSizing: 'border-box' }}>
                                        {/* Evidence Button */}
                                        <div className="position-relative" style={{ width: '100%', maxWidth: '100%' }}>
                                          <button

                                            type="button"

                                            className="btn mb-2 text-white font-weight-bold"

                                            style={{

                                              backgroundColor: '#43B97F',

                                              borderRadius: '10px',
                                              width: '100%',
                                              height: '40px',
                                              fontSize: '13px',
                                              padding: '0 8px',
                                              opacity: enableButtons ? 1 : 0.6,

                                              cursor: enableButtons ? 'pointer' : 'not-allowed',
                                              minWidth: '0',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'
                                            }}

                                            data-bs-toggle="modal"
                                            data-bs-target="#evidenceModal"
                                            onClick={() => { setSelectedQuestion(q); resetEvidenceModal(); }}
                                            disabled={!enableButtons}

                                          >

                                            {t('btn.evidence', { ns: 'framework_common', defaultValue: 'Evidence' })}

                                          </button>



                                          {hasEvidence && (

                                            <span

                                              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"

                                              title={t('tooltip.evidenceUploaded', { ns: 'smart_map', defaultValue: 'Evidence uploaded' })}

                                              style={{ fontSize: 10 }}

                                            >

                                              <i className="fa fa-check text-white" />

                                            </span>

                                          )}

                                        </div>





                                        {/* Task Button */}
                                        <div className="position-relative" style={{ width: '100%', maxWidth: '100%' }}>
                                          <button

                                            type="button"

                                            className="btn mb-2 text-success font-weight-bold d-flex align-items-center justify-content-center"

                                            style={{

                                              backgroundColor: '#eeeeee',

                                              borderRadius: '10px',
                                              width: '100%',
                                              height: '40px',
                                              fontSize: '13px',
                                              padding: '0 8px',
                                              opacity: enableButtons ? 1 : 0.6,

                                              cursor: enableButtons ? 'pointer' : 'not-allowed',
                                              minWidth: '0',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'
                                            }}

                                            onClick={() => {

                                              setSelectedCategoryId(cleanCategoryId);

                                              setModalOpen(true);

                                              setCurrentModalCategoryId(cleanCategoryId);



                                              const currentResp = nistQuestionResponses?.[activeButton]?.[cleanCategoryId];

                                              setCurrentStatus(currentResp?.status || "N/A");

                                              setCurrentPriority(currentResp?.priority || "N/A");



                                              fetchTasks(cleanCategoryId); // live refresh

                                            }}

                                            disabled={!enableButtons}

                                          >
                                            <i className="bi bi-pencil-fill mr-1" style={{ fontSize: '11px' }}></i> {t('btn.task', { ns: 'framework_common', defaultValue: 'Task' })}
                                          </button>



                                          {/* show badge only if DB has tasks */}

                                          {(taskCountByCategory[cleanCategoryId] || 0) > 0 && (

                                            <span

                                              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"

                                              title={t('tooltip.taskAdded', { ns: 'smart_map', defaultValue: 'Task added' })}

                                              style={{ fontSize: 10 }}

                                            >

                                              <i className="fa fa-check text-white" />

                                            </span>

                                          )}

                                        </div>









                                      </div>

                                      {/* <!-- Evidence Modal --> */}

                                      <div

                                        className="modal fade"

                                        id="evidenceModal"

                                        tabIndex="-1"

                                        role="dialog"

                                        aria-labelledby="evidenceModalLabel"

                                        aria-hidden="true"

                                      >

                                        <div className="modal-dialog modal-dialog-help" role="document">

                                          <div className="modal-content border-0 modal-content-custom">

                                            <div className="modal-header modal-header-custom">

                                              <h5 className="modal-title text-white" id="evidenceModalLabel">{t('btn.uploadEvidence', { ns: 'framework_common', defaultValue: 'Upload Evidence' })}</h5>

                                              <button type="button" className="close text-white" data-bs-dismiss="modal" aria-label={t('btn.close', { ns: 'common', defaultValue: 'Close' })} onClick={resetEvidenceModal}>
                                                <span aria-hidden="true">&times;</span>
                                              </button>

                                            </div>



                                            {/* Modal Body */}

                                            <div className="modal-body">

                                              {/* Upload Form */}

                                              <form onSubmit={(e) => e.preventDefault()}>

                                                {/* Row */}

                                                <div className="row">

                                                  {/* Left */}

                                                  <div className="col-md-6">

                                                    <div className="form-group d-flex align-items-center" onClick={() => document.getElementById("evidenceDate").showPicker?.()}>

                                                      <label htmlFor="evidenceDate" className="mb-0 me-2 font-weight-bold" style={{ whiteSpace: "nowrap" }}>

                                                        {t('label.selectEvidenceCollectionDate', { ns: 'smart_map', defaultValue: 'Select Evidence Collection Date:' })}

                                                        <span className="text-danger">*</span>

                                                      </label>

                                                      <DatePicker

                                                        id="evidenceDate"

                                                        selected={evidenceDate ? new Date(evidenceDate) : null}

                                                        onChange={(date) => setEvidenceDate(date ? moment(date).format("YYYY-MM-DD") : "")}

                                                        dateFormat="yyyy-MM-dd"

                                                        className="form-control form-control-sm text-uppercase"

                                                        style={{ width: "180px" }}

                                                        placeholderText="YYYY-MM-DD"

                                                        minDate={new Date(today)}

                                                        renderCustomHeader={({

                                                          date,

                                                          changeYear,

                                                          changeMonth,

                                                          decreaseMonth,

                                                          increaseMonth,

                                                          prevMonthButtonDisabled,

                                                          nextMonthButtonDisabled,

                                                        }) => (

                                                          <div style={{ margin: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                                            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ background: "none", border: "none", cursor: "pointer" }}>

                                                              {"<"}

                                                            </button>

                                                            <div style={{ display: "flex", gap: "10px" }}>

                                                              <select

                                                                value={date.getMonth()}

                                                                onChange={({ target: { value } }) => changeMonth(value)}

                                                                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}

                                                              >

                                                                {Array.from({ length: 12 }, (_, i) => (

                                                                  <option key={i} value={i}>

                                                                    {new Date(0, i).toLocaleString('default', { month: 'long' })}

                                                                  </option>

                                                                ))}

                                                              </select>

                                                              <select

                                                                value={date.getFullYear()}

                                                                onChange={({ target: { value } }) => changeYear(value)}

                                                                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}

                                                              >

                                                                {Array.from({ length: 15 }, (_, i) => {

                                                                  const year = new Date().getFullYear() - 7 + i;

                                                                  return (

                                                                    <option key={year} value={year}>

                                                                      {year}

                                                                    </option>

                                                                  );

                                                                })}

                                                              </select>

                                                            </div>

                                                            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ background: "none", border: "none", cursor: "pointer" }}>

                                                              {">"}

                                                            </button>

                                                          </div>

                                                        )}

                                                        required

                                                      />

                                                    </div>



                                                    {/* File Upload */}

                                                    <div className="form-group mt-4 text-center">

                                                      <label

                                                        htmlFor="evidenceFileUpload"

                                                        className="p-4 mx-auto"

                                                        style={{

                                                          border: "2px dashed #ccc",

                                                          borderRadius: "8px",

                                                          cursor: "pointer",

                                                          width: "100%",

                                                          maxWidth: "500px",

                                                          display: "block",

                                                        }}

                                                      >

                                                        <span className="text-muted font-weight-bold">
                                                          {evidenceFiles.length === 0 ? t('label.chooseFilesHere', { ns: 'framework_common', defaultValue: 'Choose files here' }) : t('label.addMoreFiles', { ns: 'framework_common', defaultValue: 'Add more files' })}
                                                        </span>
                                                        <span className="text-danger">*</span>

                                                      </label>

                                                      <input

                                                        id="evidenceFileUpload"

                                                        type="file"

                                                        multiple

                                                        ref={fileInputRef}

                                                        style={{ display: "none" }}

                                                        onChange={(e) => {

                                                          const newFiles = Array.from(e.target.files);

                                                          // Add to existing files instead of replacing

                                                          setEvidenceFiles(prev => {
                                                            const combined = [...prev, ...newFiles];
                                                            if (combined.length > MAX_FILES_PER_UPLOAD) {
                                                              alert(t('msg.maxFilesAllowedOnlyFirstSelected', { ns: 'smart_map', defaultValue: ' Maximum {{maxFiles}} files allowed. Only first {{maxFiles}} files will be selected.', maxFiles: MAX_FILES_PER_UPLOAD }));
                                                              return combined.slice(0, MAX_FILES_PER_UPLOAD);
                                                            }
                                                            return combined;
                                                          });
                                                          setTimeout(() => {
                                                            e.target.value = null;
                                                          }, 100);
                                                        }}
                                                      />

                                                      <div className="text-center mt-2">
                                                        <small className="text-muted" style={{ fontSize: "11px", color: "red" }}>
                                                          {t('label.maxPrefix', { ns: 'smart_map', defaultValue: 'Max' })} <strong>{MAX_FILES_PER_UPLOAD} {t('unit.files', { ns: 'smart_map', defaultValue: 'files' })}</strong> &middot; <strong>{MAX_FILE_SIZE_MB} {t('unit.mb', { ns: 'smart_map', defaultValue: 'MB' })}</strong> {t('label.perFile', { ns: 'smart_map', defaultValue: 'per file' })} &middot; <strong>{MAX_TOTAL_SIZE_MB} {t('unit.mb', { ns: 'smart_map', defaultValue: 'MB' })}</strong> {t('msg.totalSupportedFormatsSmartMap', { ns: 'smart_map', defaultValue: 'total. Supported: .pdf, .docx, .doc, .xls, .xlsx, .png, .jpeg, .gif, .bmp, .pptx, .txt, .log, .csv, .xml' })}
                                                        </small>
                                                      </div>

                                                      {evidenceFiles.length > 0 && (
                                                        <div className="mt-3">
                                                          <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <small className="text-muted font-weight-bold">
                                                              {t('msg.selectedFilesCount', { ns: 'framework_common', defaultValue: 'Selected Files ({{count}}/{{max}})', count: evidenceFiles.length, max: MAX_FILES_PER_UPLOAD })}

                                                            </small>

                                                            <button

                                                              type="button"

                                                              className="btn btn-sm btn-outline-danger"

                                                              onClick={() => setEvidenceFiles([])}

                                                              title={t('title.clearAllFiles', { ns: 'framework_common', defaultValue: 'Clear all files' })}

                                                            >

                                                              <i className="fa fa-trash"></i> {t('btn.clearAll', { ns: 'framework_common', defaultValue: 'Clear All' })}

                                                            </button>

                                                          </div>

                                                          <ul className="list-group text-left small" style={{ maxHeight: '200px', overflowY: 'auto' }}>

                                                            {evidenceFiles.map((file, idx) => (

                                                              <li key={idx} className="list-group-item d-flex justify-content-between align-items-center py-2">

                                                                <span className="text-truncate" style={{ maxWidth: '70%' }} title={file.name}>

                                                                  <i className="fa fa-file text-primary mr-2"></i>

                                                                  {file.name}

                                                                </span>

                                                                <div className="btn-group btn-group-sm" role="group">

                                                                  <button

                                                                    type="button"

                                                                    className="btn btn-sm btn-outline-primary"

                                                                    onClick={() => {

                                                                      // Replace individual file

                                                                      const input = document.createElement('input');

                                                                      input.type = 'file';

                                                                      input.multiple = false;

                                                                      input.onchange = (e) => {

                                                                        const newFile = e.target.files[0];

                                                                        if (newFile) {

                                                                          setEvidenceFiles(prev => {

                                                                            const updated = [...prev];

                                                                            updated[idx] = newFile;

                                                                            return updated;

                                                                          });

                                                                        }

                                                                      };

                                                                      input.click();

                                                                    }}

                                                                    title={t('title.replaceThisFile', { ns: 'framework_common', defaultValue: 'Replace this file' })}

                                                                  >

                                                                    <i className="fa fa-exchange"></i>

                                                                  </button>

                                                                  <button

                                                                    type="button"

                                                                    className="btn btn-sm btn-outline-danger"

                                                                    onClick={() => {

                                                                      // Remove individual file

                                                                      setEvidenceFiles(prev => prev.filter((_, i) => i !== idx));

                                                                    }}

                                                                    title={t('title.removeThisFile', { ns: 'framework_common', defaultValue: 'Remove this file' })}

                                                                  >

                                                                    <i className="fa fa-times"></i>

                                                                  </button>

                                                                </div>

                                                              </li>

                                                            ))}

                                                          </ul>

                                                        </div>

                                                      )}

                                                      {/* <div className="text-danger small mt-2">

                                                        Maximum allowed 20 files of 50 mb. Supported: .pdf, .docx, .doc, .xls, .xlsx, .png, .jpeg, .gif, .bmp, .pptx, .txt, .log, .csv, .xml

                                                      </div> */}

                                                    </div>

                                                  </div>



                                                  {/* Right */}

                                                  <div className="col-md-6">

                                                    <div className="form-group">

                                                      <label htmlFor="gatheringMethod">

                                                        {t('label.evidenceGatheringMethodColon', { ns: 'smart_map', defaultValue: 'Evidence Gathering Method:' })} <span className="text-danger">*</span>

                                                      </label>

                                                      <textarea

                                                        id="gatheringMethod"

                                                        className="form-control"

                                                        rows="6"

                                                        value={gatheringMethod}

                                                        onChange={(e) => setGatheringMethod(e.target.value)}

                                                      />

                                                    </div>

                                                  </div>



                                                </div>



                                                {/* Bottom */}

                                                <div className="form-group d-flex justify-content-between align-items-center mt-3 flex-wrap">

                                                  <div className="form-check d-flex align-items-center mb-0" style={{ flex: 1 }}>

                                                    <input

                                                      className="form-check-input"

                                                      type="checkbox"

                                                      id="verifiedCheck"

                                                      checked={verified}

                                                      onChange={(e) => setVerified(e.target.checked)}

                                                    />

                                                    <label className="form-check-label font-weight-bold ms-2 mb-0" htmlFor="verifiedCheck">

                                                      {t('label.verifiedByAuditor', { ns: 'framework_common', defaultValue: 'Verified by Internal Auditor / Authorized Person' })}  <span className="text-danger">*</span>

                                                    </label>

                                                  </div>

                                                  <>

                                                    {/* Email Input */}

                                                    <div className="d-flex flex-column align-items-end" style={{ flex: 1 }}>

                                                      <div className="d-flex align-items-center mb-0 w-100" style={{ justifyContent: "flex-end" }}>

                                                        <label

                                                          htmlFor="ownerEmail"

                                                          className="mb-0 me-2 font-weight-bold"

                                                          style={{ whiteSpace: "nowrap" }}

                                                        >

                                                          {t('label.ownerEmail', { ns: 'framework_common', defaultValue: 'Owner Email' })}:  <span className="text-danger">*</span>

                                                        </label>

                                                        <input

                                                          type="email"

                                                          className="form-control form-control-sm"

                                                          id="ownerEmail"

                                                          style={{ width: "365px" }}

                                                          value={ownerEmail}

                                                          onChange={(e) => {

                                                            setOwnerEmail(e.target.value);

                                                            setEmailError(""); // clear while typing

                                                          }}

                                                        />

                                                      </div>



                                                      {/* Error Message */}

                                                      {emailError && (

                                                        <small className="text-danger mt-1 me-1" style={{ alignSelf: "flex-end" }}>

                                                          {emailError}

                                                        </small>

                                                      )}

                                                    </div>



                                                  </>

                                                  <div>



                                                  </div>

                                                </div>

                                                {/* Category ID Badge (only shown if matching data exists) */}

                                                {false && (

                                                  <div className="d-flex justify-content-between align-items-center mb-3">

                                                    <span className="px-3 py-2 border border-success rounded text-success font-weight-bold">

                                                      {selectedQuestion?.categoryid || "N/A"}

                                                    </span>

                                                  </div>

                                                )}







                                              </form>

                                            </div>

                                            {/* Table for Previous Evidence (SHOW ONLY IF DATA EXISTS) */}

                                            {!loading && (

                                              <>

                                                {/* Evidence Table */}

                                                <div className="p-3" style={{ maxHeight: "300px", overflowY: "auto" }}>

                                                  <div

                                                    className="table-responsive mt-4"

                                                    style={{ border: '1px solid #ccc', borderRadius: '5px', minHeight: '150px' }}

                                                  >

                                                    <table className="table table-bordered small mb-0">

                                                      <thead className="bg-primary text-white">

                                                        <tr>

                                                          <th>{t('th.srNo', { ns: 'framework_common', defaultValue: 'Sr.No' })}</th>

                                                          <th>{t('th.uploadedDate', { ns: 'smart_map', defaultValue: 'Uploaded Date' })}</th>

                                                          <th>{t('th.evidenceDate', { ns: 'smart_map', defaultValue: 'Evidence Date' })}</th>

                                                          <th>{t('th.function', { ns: 'smart_map', defaultValue: 'Function' })}</th>

                                                          <th>{t('th.subcategory', { ns: 'smart_map', defaultValue: 'Subcategory' })}</th>

                                                          <th>{t('th.categoryId', { ns: 'smart_map', defaultValue: 'Category ID' })}</th>

                                                          <th>{t('btn.view', { ns: 'common', defaultValue: 'View' })}</th>

                                                          <th>{t('th.verifiedEvidence', { ns: 'framework_common', defaultValue: 'Verified Evidence' })}</th>

                                                        </tr>

                                                      </thead>

                                                      <tbody>

                                                        {(() => {

                                                          const filtered = evidenceTableData.filter(row =>

                                                            selectedQuestion

                                                              ? row.categoryId?.replace(/:$/, "") === selectedQuestion.categoryid?.replace(/:$/, "")

                                                              : true

                                                          );



                                                          const total = filtered.length;

                                                          const paginated = filtered.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);



                                                          return paginated.length > 0 ? (

                                                            paginated.map((row, idx) => (

                                                              <tr key={`${row.categoryId}-${row.fileName}-${row.collectionDate}-${idx}`}>

                                                                <td>{total - ((currentPage - 1) * rowsPerPage + idx)}</td>

                                                                <td>{row.uploadedDate ? moment.utc(row.uploadedDate).local().format('YYYY-MM-DD HH:mm:ss') : t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}</td>

                                                                <td>{row.collectionDate}</td>

                                                                <td>{row.function}</td>

                                                                <td>{row.subCategory}</td>

                                                                <td>{row.categoryId}</td>

                                                                <td>

                                                                  {row.s3Path ? (

                                                                    <a

                                                                      href={encodeURI(row.s3Path)}

                                                                      onClick={(e) => handleFileDownload(e, row.s3Path, row.fileName)}

                                                                      style={{ color: "teal", textDecoration: "underline", cursor: 'pointer' }}

                                                                    >

                                                                      {cleanFileName(row.fileName)}

                                                                    </a>

                                                                  ) : (

                                                                    <span className="text-muted">{t('msg.noFile', { ns: 'framework_common', defaultValue: 'No File' })}</span>

                                                                  )}

                                                                </td>

                                                                <td>{row.verified ? t('label.yes', { ns: 'framework_common', defaultValue: 'Yes' }) : t('label.no', { ns: 'framework_common', defaultValue: 'No' })}</td>

                                                              </tr>

                                                            ))

                                                          ) : (

                                                            <tr>

                                                              <td colSpan="8" className="text-center text-muted">

                                                                {t('msg.noEvidenceUploadedYet', { ns: 'framework_common', defaultValue: 'No evidence uploaded yet' })}

                                                              </td>

                                                            </tr>

                                                          );

                                                        })()}

                                                      </tbody>

                                                    </table>

                                                  </div>

                                                </div>



                                                {/* Pagination Controls */}

                                                {(() => {

                                                  const filtered = evidenceTableData.filter(row =>

                                                    selectedQuestion

                                                      ? row.categoryId?.replace(/:$/, "") === selectedQuestion.categoryid?.replace(/:$/, "")

                                                      : true

                                                  );



                                                  const totalEntries = filtered.length;

                                                  const totalPages = Math.ceil(totalEntries / rowsPerPage);

                                                  const startEntry = (currentPage - 1) * rowsPerPage + 1;

                                                  const endEntry = startEntry + rowsPerPage - 1;



                                                  return (

                                                    <div className="d-flex justify-content-between align-items-center mt-2 px-3">

                                                      {/* Showing text on LEFT */}

                                                      <div className="text-muted">

                                                        {totalEntries > 0 ? (

                                                          <p className="mb-0">

                                                            {t('msg.showingEntriesRange', { ns: 'framework_common', defaultValue: 'Showing {{start}} to {{end}} of {{total}} entries', start: Math.min(startEntry, totalEntries), end: Math.min(endEntry, totalEntries), total: totalEntries })}

                                                          </p>

                                                        ) : (

                                                          <p className="mb-0">{t('msg.noEntriesFound', { ns: 'framework_common', defaultValue: 'No entries found' })}</p>

                                                        )}

                                                      </div>



                                                      {/* Pagination on RIGHT */}

                                                      <nav aria-label={t('label.pageNavigation', { ns: 'smart_map', defaultValue: 'Page navigation' })}>

                                                        <ul className="pagination mb-0">

                                                          {/* Previous Button */}

                                                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>

                                                            <button

                                                              className="page-link"

                                                              onClick={() => {

                                                                if (currentPage > 1) setCurrentPage(currentPage - 1);

                                                              }}

                                                            >

                                                              {t('btn.previous', { ns: 'common', defaultValue: 'Previous' })}

                                                            </button>

                                                          </li>



                                                          {/* Page Numbers (Descending) */}

                                                          {[...Array(totalPages).keys()].map((page) => {

                                                            const pageNumber = page + 1;

                                                            const label = totalPages - page;

                                                            return (

                                                              <li key={label} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>

                                                                <button

                                                                  className="page-link"

                                                                  onClick={() => setCurrentPage(pageNumber)}

                                                                >

                                                                  {label}

                                                                </button>

                                                              </li>

                                                            );

                                                          })}



                                                          {/* Next Button */}

                                                          <li className={`page-item ${currentPage >= totalPages ? "disabled" : ""}`}>

                                                            <button

                                                              className="page-link"

                                                              onClick={() => {

                                                                if (currentPage < totalPages) {

                                                                  setCurrentPage(currentPage + 1);

                                                                }

                                                              }}

                                                            >

                                                              {t('btn.next', { ns: 'common', defaultValue: 'Next' })}

                                                            </button>

                                                          </li>

                                                        </ul>

                                                      </nav>

                                                    </div>

                                                  );

                                                })()}





                                              </>

                                            )}





                                            {/* Modal Footer */}

                                            <div className="modal-footer">

                                              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={resetEvidenceModal}>{t('btn.close', { ns: 'common', defaultValue: 'Close' })}</button>

                                              {/* Progress bar during upload */}
                                              {uploadProgress.show && (
                                                <div className="mt-3 mb-3 w-100 px-3">
                                                  <small className="text-muted">
                                                    {evidenceFiles.length > 1
                                                      ? t('msg.uploadingFilesPluralPercent', { ns: 'smart_map', defaultValue: 'Uploading {{count}} files... {{percentage}}%', count: evidenceFiles.length, percentage: uploadProgress.percentage })
                                                      : t('msg.uploadingFileSingularPercent', { ns: 'smart_map', defaultValue: 'Uploading {{count}} file... {{percentage}}%', count: evidenceFiles.length, percentage: uploadProgress.percentage })}
                                                  </small>
                                                  <div className="progress mt-1" style={{ height: '6px' }}>
                                                    <div
                                                      className="progress-bar bg-success"
                                                      style={{ width: `${uploadProgress.percentage}%`, transition: 'width 0.3s ease' }}
                                                    />
                                                  </div>
                                                </div>
                                              )}
                                              <button type="button" className="btn btn-success" onClick={handleEvidenceSubmit} disabled={isEvidenceSaving}>
                                                {isEvidenceSaving ? t('msg.uploadingPercent', { ns: 'smart_map', defaultValue: 'Uploading {{percentage}}%', percentage: uploadProgress.percentage }) : t('btn.save', { ns: 'common', defaultValue: 'Save' })}
                                              </button>

                                            </div>



                                          </div>

                                        </div>

                                      </div>

                                      {/* <!-- Examples Modal --> */}

                                      <div

                                        className="modal fade"

                                        id="helpModal"

                                        tabIndex="-1"

                                        role="dialog"

                                        aria-labelledby="helpModalLabel"

                                        aria-hidden="true"

                                      >

                                        <div className="modal-dialog modal-lg modal-dialog-custom" role="document">

                                          <div className="modal-content border-0 modal-content-custom">

                                            <div className="modal-header modal-header-custom">

                                              <h5 className="modal-title" id="helpModalLabel">{t('title.implementationExamples', { ns: 'framework_common', defaultValue: 'Implementation Examples' })}</h5>

                                              <button

                                                type="button"

                                                className="close text-white"

                                                data-dismiss="modal"

                                                aria-label={t('btn.close', { ns: 'common', defaultValue: 'Close' })}

                                              >

                                                <span aria-hidden="true">×</span>

                                              </button>

                                            </div>



                                            <div className="modal-body">

                                              <div className="px-2">

                                                {getExamplesForId(selectedExampleId)?.length > 0 ? (

                                                  getExamplesForId(selectedExampleId).map((ex, i) => (

                                                    <div

                                                      key={i}

                                                      className="mb-2"

                                                      style={{ fontSize: "15px", color: "#4a4a4a" }}

                                                    >

                                                      {`${i + 1}. ${ex}`}

                                                    </div>

                                                  ))

                                                ) : (

                                                  <div className="text-muted">{t('msg.noExamplesAvailable', { ns: 'framework_common', defaultValue: 'No examples available for this ID.' })}</div>

                                                )}

                                              </div>

                                            </div>



                                            <div className="modal-footer">

                                              <button

                                                type="button"

                                                className="btn btn-danger text-white"

                                                data-dismiss="modal"

                                              >

                                                {t('btn.close', { ns: 'common', defaultValue: 'Close' })}

                                              </button>

                                            </div>

                                          </div>

                                        </div>

                                      </div>

                                      <div>



                                        {/* <!-- Taskn Modal --> */}

                                        {/* <!-- Task Details Modal --> */}

                                        {index === 0 && modalOpen && (

                                          <div

                                            className="modal show d-block"

                                            tabIndex="-1"

                                            onClick={(e) => {

                                              // Close only if background (not dialog) is clicked

                                              if (e.target.classList.contains('modal')) {

                                                setModalOpen(false);

                                              }

                                            }}

                                          >

                                            <div className="modal-dialog modal-lg modal-dialog-createtask" role="document" style={{ maxHeight: '90vh' }}>

                                              <div className="modal-content border-0 modal-content-custom">

                                                <div className="modal-header modal-header-custom">

                                                  <h5 className="modal-title text-white">{t('title.taskDetails', { ns: 'framework_common', defaultValue: 'Task Details' })}</h5>

                                                  <button

                                                    type="button"

                                                    className="close text-white"

                                                    aria-label={t('btn.close', { ns: 'common', defaultValue: 'Close' })}

                                                    onClick={() => setModalOpen(false)} // CLOSE MODAL

                                                  >

                                                    <span aria-hidden="true">&times;</span>

                                                  </button>

                                                </div>

                                                <div class="modal-body" >

                                                  <div class="d-flex justify-content-between">

                                                    <span className="px-3 py-2 border border-success rounded text-success bg-light font-weight-bold">

                                                      {selectedCategoryId}

                                                    </span>

                                                    <button

                                                      type="button"

                                                      className="btn btn-success font-weight-bold px-3 rounded-pill"

                                                      onClick={() => {

                                                        setModalOpen(false);

                                                        setShowCreateModal(true);

                                                      }} // handle create task modal separately

                                                    >

                                                      {t('btn.createTask', { ns: 'framework_common', defaultValue: 'Create Task' })}

                                                    </button>

                                                  </div>

                                                  {/* STATUS + TARGET */}

                                                  <div className="row mt-4 align-items-center">

                                                    {/* Label Column */}

                                                    <div className="col-lg-2">

                                                      <label className="fw-semibold">{t('label.status', { ns: 'framework_common', defaultValue: 'Status' })}</label>

                                                    </div>



                                                    {/* Inputs Column */}

                                                    <div className="col-lg-6 d-flex align-items-end gap-4">



                                                      {/* Current Status Button */}

                                                      <div className="d-flex flex-column">

                                                        <label className="mb-1">{t('label.current', { ns: 'framework_common', defaultValue: 'Current' })}</label>

                                                        <button

                                                          className="text-white fw-bold"

                                                          style={{

                                                            backgroundColor: '#8a8dbb',

                                                            border: 'none',

                                                            width: '130px',

                                                            height: '42px',

                                                            fontSize: '0.75rem',

                                                            borderRadius: '8px',

                                                            whiteSpace: 'nowrap',

                                                            textAlign: 'center',

                                                          }}

                                                          disabled

                                                        >

                                                          {currentStatus ? t(statusLabelKeys[currentStatus] || 'label.notAvailable', { ns: 'framework_common', defaultValue: currentStatus }) : t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}

                                                        </button>

                                                      </div>



                                                      {/* Target Input */}

                                                      <div className="d-flex flex-column">

                                                        <label className="mb-1">

                                                          {t('label.target', { ns: 'framework_common', defaultValue: 'Target' })}<span className="text-danger">*</span>

                                                        </label>

                                                        <input

                                                          type="text"

                                                          className="form-control soft-box text-center"

                                                          value={t('status.inPractice', { ns: 'framework_common', defaultValue: 'In Practice' })}

                                                          disabled

                                                          style={{

                                                            width: '130px',

                                                            height: '42px',

                                                            fontSize: '0.85rem',

                                                            borderRadius: '8px',

                                                            backgroundColor: '#f2f2f2',

                                                          }}

                                                        />

                                                      </div>

                                                    </div>

                                                  </div>





                                                  {/* PRIORITY */}

                                                  <div className="row mt-3 align-items-center">

                                                    {/* Label Column */}

                                                    <div className="col-lg-2">

                                                      <label className="fw-semibold">

                                                        {t('label.priority', { ns: 'framework_common', defaultValue: 'Priority' })}<span className="text-danger">*</span>

                                                      </label>

                                                    </div>



                                                    {/* Inputs Column */}

                                                    <div className="col-lg-6 d-flex align-items-end gap-4">



                                                      {/* Current Priority Button */}

                                                      <div className="d-flex flex-column">

                                                        <button

                                                          className="text-white fw-bold"

                                                          style={{

                                                            backgroundColor: '#8a8dbb',

                                                            border: 'none',

                                                            width: '130px',

                                                            height: '42px',

                                                            fontSize: '0.75rem',

                                                            borderRadius: '8px',

                                                            whiteSpace: 'nowrap',

                                                            overflow: 'hidden',

                                                            textOverflow: 'ellipsis',

                                                            textAlign: 'center',

                                                          }}

                                                          disabled

                                                        >

                                                          {currentPriority ? t(priorityLabelKeys[currentPriority] || 'label.notAvailable', { ns: 'framework_common', defaultValue: currentPriority }) : t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}

                                                        </button>

                                                      </div>



                                                      {/* Target Priority Input */}

                                                      <div className="d-flex flex-column">

                                                        <input

                                                          type="text"

                                                          className="form-control soft-box text-center"

                                                          value={t('priority.high', { ns: 'framework_common', defaultValue: 'High' })}

                                                          disabled

                                                          style={{

                                                            width: '130px',

                                                            height: '42px',

                                                            fontSize: '0.85rem',

                                                            borderRadius: '8px',

                                                            backgroundColor: '#f2f2f2',

                                                          }}

                                                        />

                                                      </div>

                                                    </div>

                                                  </div>





                                                  {/* Table */}

                                                  <div className="table-responsive mt-4" style={{ maxHeight: '250px', overflowY: 'auto', overflowX: 'hidden' }}>

                                                    <table className="table table-bordered">

                                                      <thead className="bg-primary text-white">

                                                        <tr>

                                                          <th>{t('th.srNo', { ns: 'framework_common', defaultValue: 'Sr.No' })}</th> {/* New column */}

                                                          <th>{t('label.dueDate', { ns: 'framework_common', defaultValue: 'Due Date' })}</th>

                                                          <th>{t('th.userAssigned', { ns: 'framework_common', defaultValue: 'User Assigned' })}</th>

                                                          <th>{t('label.taskTitle', { ns: 'framework_common', defaultValue: 'Task Title' })}</th>

                                                          <th>{t('label.taskDescription', { ns: 'framework_common', defaultValue: 'Task Description' })}</th>

                                                        </tr>

                                                      </thead>

                                                      <tbody>

                                                        {tasks.length > 0 ? (

                                                          tasks.map((task, index) => (

                                                            <tr key={index}>

                                                              <td>{tasks.length - index}</td> {/* Reverse numbering */}

                                                              <td>{task?.dueDate ? moment(task.dueDate).format("YYYY-MM-DD") : t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}</td>

                                                              <td>{task?.taskOwner || t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}</td>

                                                              <td>{task?.taskTitle || t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}</td>

                                                              <td>{task?.taskDescription || t('label.notAvailable', { ns: 'framework_common', defaultValue: 'N/A' })}</td>

                                                            </tr>

                                                          ))

                                                        ) : (

                                                          <tr>

                                                            <td colSpan="5" className="text-center">{t('msg.noTasksAvailable', { ns: 'framework_common', defaultValue: 'No tasks available' })}</td> {/* updated colSpan from 4 → 5 */}

                                                          </tr>

                                                        )}

                                                      </tbody>



                                                    </table>



                                                  </div>

                                                </div>

                                              </div>

                                            </div>

                                          </div>

                                        )}

                                        {/* Create Task Modal */}

                                        {index === 0 && showCreateModal && (

                                          <div

                                            className="modal show d-block"

                                            tabIndex="-1"

                                            onClick={(e) => {

                                              // Close only if background (not dialog) is clicked

                                              if (e.target.classList.contains('modal')) {

                                                setShowCreateModal(false);

                                              }

                                            }}

                                          >

                                            <div className="modal-dialog modal-lg modal-dialog-custom" role="document">

                                              <div className="modal-content border-0 modal-content-custom">

                                                <div className="modal-header modal-header-custom">

                                                  <h1 className="fs-5 text-white">{t('btn.createTask', { ns: 'framework_common', defaultValue: 'Create Task' })}</h1>

                                                  <button

                                                    type="button"

                                                    className="close text-white"

                                                    onClick={() => setShowCreateModal(false)}

                                                    aria-label={t('btn.close', { ns: 'common', defaultValue: 'Close' })}

                                                  >

                                                    <span aria-hidden="true">×</span>

                                                  </button>

                                                </div>

                                                <div className="modal-body">

                                                  <div className="row justify-content-end mb-3">

                                                    <div className="d-flex justify-content-between align-items-center mb-3">

                                                      <span className="px-2 py-1 border border-success rounded text-success bg-light font-weight-bold">

                                                        {selectedCategoryId}

                                                      </span>

                                                      <div className="col-md-6 mb-0">

                                                        <div

                                                          onClick={() => document.getElementById("toDate").showPicker?.()}

                                                        >

                                                          <label htmlFor="toDate" className="mr-2 font-weight-bold ">{t('label.dueDate', { ns: 'framework_common', defaultValue: 'Due Date' })}:</label>

                                                          <DatePicker

                                                            id="toDate"

                                                            selected={dueDate ? new Date(dueDate) : null}

                                                            onChange={(date) => setDueDate(date ? moment(date).format("YYYY-MM-DD") : "")}

                                                            dateFormat="yyyy-MM-dd"

                                                            className="form-control text-uppercase"

                                                            placeholderText="YYYY-MM-DD"

                                                            minDate={new Date(today)}
                                                            maxDate={new Date(new Date(today).setMonth(new Date(today).getMonth() + 2))}

                                                            renderCustomHeader={({

                                                              date,

                                                              changeYear,

                                                              changeMonth,

                                                              decreaseMonth,

                                                              increaseMonth,

                                                              prevMonthButtonDisabled,

                                                              nextMonthButtonDisabled,

                                                            }) => (

                                                              <div style={{ margin: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ background: "none", border: "none", cursor: "pointer" }}>

                                                                  {"<"}

                                                                </button>

                                                                <div style={{ display: "flex", gap: "10px" }}>

                                                                  <select

                                                                    value={date.getMonth()}

                                                                    onChange={({ target: { value } }) => changeMonth(value)}

                                                                    style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}

                                                                  >

                                                                    {Array.from({ length: 12 }, (_, i) => (

                                                                      <option key={i} value={i}>

                                                                        {new Date(0, i).toLocaleString('default', { month: 'long' })}

                                                                      </option>

                                                                    ))}

                                                                  </select>

                                                                  <select

                                                                    value={date.getFullYear()}

                                                                    onChange={({ target: { value } }) => changeYear(value)}

                                                                    style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}

                                                                  >

                                                                    {Array.from({ length: 15 }, (_, i) => {

                                                                      const year = new Date().getFullYear() - 7 + i;

                                                                      return (

                                                                        <option key={year} value={year}>

                                                                          {year}

                                                                        </option>

                                                                      );

                                                                    })}

                                                                  </select>

                                                                </div>

                                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ background: "none", border: "none", cursor: "pointer" }}>

                                                                  {">"}

                                                                </button>

                                                              </div>

                                                            )}

                                                            required

                                                          />

                                                        </div>

                                                      </div>

                                                    </div>

                                                  </div>

                                                  <div className="row align-items-end mb-3">

                                                    <div className="col-md-8">

                                                      <label htmlFor="taskTitle">{t('label.taskTitle', { ns: 'framework_common', defaultValue: 'Task Title' })}</label>

                                                      <input

                                                        type="text"

                                                        className="form-control"

                                                        id="taskTitle"

                                                        value={taskTitle}

                                                        onChange={(e) => setTaskTitle(e.target.value)}

                                                      />

                                                    </div>

                                                    <div className="col-md-4">
                                                      <button
                                                        type="button"
                                                        className="btn btn-warning px-2"
                                                        onClick={() => setShowOwnerDropdown(!showOwnerDropdown)}
                                                      >
                                                        {t('btn.addTaskOwner', { ns: 'framework_common', defaultValue: 'Add Task Owner' })}
                                                      </button>
                                                    </div>
                                                  </div>
                                                  {showOwnerDropdown && (
                                                    <div className="row mb-3">
                                                      <div className="col-md-8">
                                                        <label htmlFor="taskOwner">{t('label.selectUser', { ns: 'framework_common', defaultValue: 'Select User' })}</label>
                                                        <select
                                                          className="form-select"
                                                          id="taskOwner"
                                                          value={taskOwner}
                                                          onChange={(e) => setTaskOwner(e.target.value)}
                                                        >
                                                          <option value="">{t('option.selectOwner', { ns: 'smart_map', defaultValue: 'Select Owner' })}</option>
                                                          {users.map((user) => (
                                                            <option key={user.id} value={user.id}>
                                                              {user.first_name} {user.last_name}
                                                            </option>
                                                          ))}
                                                        </select>
                                                      </div>
                                                    </div>
                                                  )}
                                                  <div className="row mt-3">
                                                    <div className="col-md-12">
                                                      <label htmlFor="taskDescription">{t('label.taskDescription', { ns: 'framework_common', defaultValue: 'Task Description' })}</label>
                                                      <textarea
                                                        className="form-control"
                                                        id="taskDescription"
                                                        rows="3"
                                                        placeholder={t('placeholder.taskDescriptionShort', { ns: 'smart_map', defaultValue: 'Task description' })}
                                                        value={taskDescription}
                                                        onChange={(e) => setTaskDescription(e.target.value)}

                                                      ></textarea>

                                                    </div>

                                                  </div>

                                                </div>

                                                <div className="modal-footer">

                                                  <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={async () => {
                                                      const success = await handleSave();
                                                      if (success) {
                                                        setShowCreateModal(false);
                                                        setModalOpen(true);
                                                      }
                                                    }}
                                                  >
                                                    {t('btn.save', { ns: 'common', defaultValue: 'Save' })}
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      </div>

                                    </div>

                                  </div>

                                  {/* Buttons and Color Logic*/}

                                  <div
                                    className="card-footer d-flex flex-nowrap ml-2"
                                    style={{

                                      padding: "8px",

                                      gap: "8px",

                                      width: "100%",

                                    }}

                                  >

                                    {status.map((label) => (

                                      <button

                                        key={label}

                                        type="button"
                                        className="btn setbtn fw-semibold"
                                        style={{
                                          flex: "1 1 auto",               // Buttons grow equally to fill available space at any zoom
                                          padding: "6px 8px",
                                          fontSize: "12px",
                                          whiteSpace: "nowrap",           // Keep single line inside button

                                          borderRadius: "13px",

                                          backgroundColor:

                                            activeStatus?.[activeButton]?.[cleanCategoryId] === label

                                              ? "#736DD5"

                                              : "#6c757d",

                                          color: "#FFFFFF",

                                        }}

                                        onClick={() => updateQuestionResponse(cleanCategoryId, "status", label)}

                                      >

                                        {t(statusLabelKeys[label], { ns: 'framework_common', defaultValue: label })}

                                      </button>

                                    ))}

                                  </div>

                                </div>

                              </div>

                            );

                          })}

                      </div>

                    </div>

                  </div> {/*end::Row*/}

                </div> {/*end::Container*/}

              </div> {/*end::App Content Header*/} {/*begin::App Content*/}

            </div>

          </div>

        </div>

      </main>

    </div>

  )

}



export default ViewSmartMap